import Global from "../Global/Global";

const Dictionary = {
  "App": {
    "You have to wait for {delay} second(s) before doing this action again.": {
      "EN": "You have to wait for {delay} second(s) before doing this action again.",
      "FR": "Vous devez attendre {delay} seconde(s) avant de pouvoir effectuer cette action à nouveau.",
      "ES": "Debe esperar {delay} segundo(s) antes de volver a realizar esta acción."
    },
    "Return": {
      "EN": "Return",
      "FR": "Retour",
      "ES": "Volver"
    },
    "Back": {
      "EN": "Back",
      "FR": "Retour",
      "ES": "Atrás"
    },
    "Refresh": {
      "EN": "Refresh",
      "FR": "Rafraîchir",
      "ES": "Actualizar"
    },
    "Process Designer": {
      "EN": "Process Designer",
      "FR": "Éditeur de processus",
      "ES": "Diseñador de Procesos"
    },
    "Close": {
      "EN": "Close",
      "FR": "Fermer",
      "ES": "Cerrar"
    },
    "Save": {
      "EN": "Save",
      "FR": "Enregistrer",
      "ES": "Guardar"
    },
    "Confirm": {
      "EN": "Confirm",
      "FR": "Confirmer",
      "ES": "Confirmar"
    },
    "Home": {
      "EN": "Home",
      "FR": "Accueil",
      "ES": "Inicio"
    },
    "Submit": {
      "EN": "Submit",
      "FR": "Envoyer",
      "ES": "Enviar"
    },
    "Loading": {
      "EN": "Loading",
      "FR": "Chargement",
      "ES": "Cargando"
    },
    "Yes": {
      "EN": "Yes",
      "FR": "Oui",
      "ES": "Sí"
    },
    "No": {
      "EN": "No",
      "FR": "Non",
      "ES": "No"
    },
    "Ok": {
      "EN": "Ok",
      "FR": "Ok",
      "ES": "Ok"
    },
    "Cancel": {
      "EN": "Cancel",
      "FR": "Annuler",
      "ES": "Cancelar"
    },
    "Delete": {
      "EN": "Delete",
      "FR": "Supprimer",
      "ES": "Eliminar"
    },
    "Error": {
      "EN": "Error",
      "FR": "Erreur",
      "ES": "Error"
    },
    "Warning": {
      "EN": "Warning",
      "FR": "Avertissement",
      "ES": "Advertencia"
    },
    "Sorry, an unknown error has occurred. Please try again later or contact our support team for assistance.": {
      "EN": "Sorry, an unknown error has occurred. Please try again later or contact our support team for assistance.",
      "FR": "Désolé, une erreur inconnue est survenue. Veuillez réessayer ultérieurement ou contacter notre équipe de support pour obtenir de l'aide.",
      "ES": "Lo sentimos, ha ocurrido un error desconocido. Por favor, inténtalo de nuevo más tarde o ponte en contacto con nuestro equipo de soporte para obtener ayuda."
    },
    "The form contains errors. Please check and fix the fields highlighted in red.": {
      "EN": "The form contains errors. Please check and fix the fields highlighted in red.",
      "FR": "Le formulaire contient des erreurs. Veuillez vérifier et corriger les champs en rouge.",
      "ES": "El formulario contiene errores. Por favor, compruebe y corrija los campos resaltados en rojo."
    },
    "User doesn't exist.": {
      "EN": "User doesn't exist.",
      "FR": "L'utilisateur n'existe pas.",
      "ES": "El usuario no existe."
    },
    "Language": {
      "EN": "Language",
      "FR": "Langue",
      "ES": "Idioma"
    },
    "Temperature Unit": {
      "EN": "Temperature Unit",
      "FR": "Unité de température",
      "ES": "Unidad de temperatura"
    },
    "Access Denied: You don't have...": {
      "EN": "Access Denied: You don't have the necessary permissions to access this component.",
      "FR": "Accès refusé : Vous n'avez pas les permissions nécessaires pour accéder à ce composant.",
      "ES": "Acceso denegado: No tienes los permisos necesarios para acceder a este componente."
    },
    "New": {
      "EN": "New",
      "FR": "Nouveau",
      "ES": "Nuevo"
    },
    "Record no longer exist": {
      "EN": "The record you are trying to access no longer exists.",
      "FR": "L'enregistrement que vous essayez d'accéder n'existe plus.",
      "ES": "El registro al que intenta acceder ya no existe."
    },
    "The record you are trying to update can't be found.": {
      "EN": "The record you are trying to update can't be found.",
      "FR": "Le dossier que vous essayez de mettre à jour est introuvable.",
      "ES": "No se puede encontrar el registro que estás intentando actualizar."
    },
    "The record you are trying to delete can't be found.": {
      "EN": "The record you are trying to delete can't be found.",
      "FR": "Le dossier que vous essayez de supprimer est introuvable.",
      "ES": "No se puede encontrar el registro que estás intentando eliminar."
    },
    "Are you sure you want to close without saving": {
      "EN": "Are you sure you want to close without saving? All unsaved changes will be lost.",
      "FR": "Êtes-vous sûr de vouloir fermer sans enregistrer ? Toutes les modifications non enregistrées seront perdues.",
      "ES": "¿Estás seguro de que deseas cerrar sin guardar? Se perderán todos los cambios no guardados."
    },
    "Duplicate Name": {
      "EN": "Duplicate name found, please use a unique name.",
      "FR": "Nom en double trouvé, veuillez utiliser un nom unique.",
      "ES": "Se encontró un nombre duplicado, por favor use un nombre único."
    },
    "Are you sure you want to delete this entity?": {
      "EN": "Are you sure you want to delete this entity?",
      "FR": "Êtes-vous sûr de vouloir supprimer cette entité ?",
      "ES": "¿Está seguro de que desea eliminar esta entidad?"
    },
    "And": {
      "EN": "And",
      "FR": "Et",
      "ES": "Y"
    },
    "Or": {
      "EN": "Or",
      "FR": "Ou",
      "ES": "O"
    },
    "Select": {
      "EN": "Select",
      "FR": "Sélectionner",
      "ES": "Seleccionar"
    },
    "Action": {
      "EN": "Action",
      "FR": "Action",
      "ES": "Acción"
    },
    "Remove": {
      "EN": "Remove",
      "FR": "Supprimer",
      "ES": "Eliminar"
    },
    "A new version of this application is...": {
      "EN": "A new version of this application is available. Please refresh the application to continue.",
      "FR": "Une nouvelle version de cette application est disponible. Veuillez rafraîchir l'application pour continuer.",
      "ES": "Una nueva versión de esta aplicación está disponible. Por favor, actualice la aplicación para continuar."
    }
  },
  "Setting": {
    "Settings": {
      "EN": "Settings",
      "FR": "Paramètres",
      "ES": "Configuraciones"
    },
    "Temperature Unit": {
      "EN": "Temperature Unit",
      "FR": "Unité de température",
      "ES": "Unidad de temperatura"
    },
    "Delete account": {
      "EN": "Delete account",
      "FR": "Supprimer le compte",
      "ES": "Eliminar cuenta"
    }
  },
  "Account": {
    "Sign out": {
      "EN": "Sign out",
      "FR": "Se déconnecter",
      "ES": "Cerrar sesión"
    },
    "Settings": {
      "EN": "Settings",
      "FR": "Paramètres",
      "ES": "Configuraciones"
    }
  },
  "Contact": {
    "Contact": {
      "EN": "Contact",
      "FR": "Contact",
      "ES": "Contacto"
    },
  },
  "AuthForgot": {
    "Forgotten password": {
      "EN": "Forgotten password",
      "FR": "Mot de passe oublié",
      "ES": "Contraseña olvidada"
    },
    "Email": {
      "EN": "Email",
      "FR": "Courriel",
      "ES": "Correo electrónico"
    },
    "Enter the email address associated with your Innovair Solutions account...": {
      "EN": "Enter the email address associated with your Innovair Solutions account. We’ll send you a secure link to reset your password. If you don’t see it within a few minutes, please check your spam or junk folder.",
      "FR": "Entrez l'adresse e-mail associée à votre compte Innovair Solutions. Nous vous enverrons un lien sécurisé pour réinitialiser votre mot de passe. Si vous ne le voyez pas dans quelques minutes, veuillez vérifier votre dossier de spam ou de courrier indésirable.",
      "ES": "Ingrese la dirección de correo electrónico asociada con su cuenta de Innovair Solutions. Le enviaremos un enlace seguro para restablecer su contraseña. Si no lo ve en unos minutos, verifique su carpeta de spam o correo no deseado."
    },
    "Send reset link": {
      "EN": "Send reset link",
      "FR": "Envoyer le lien de réinitialisation",
      "ES": "Enviar enlace de restablecimiento"
    },
    "Please enter your email address.": {
      "EN": "Please enter your email address.",
      "FR": "Veuillez entrer votre adresse e-mail.",
      "ES": "Por favor, ingrese su dirección de correo electrónico."
    },
    "The email address you entered isn’t associated with any account. Double-check your email or sign up to get started.": {  
      "EN": "The email address you entered isn’t associated with any account. Double-check your email or sign up to get started.",
      "FR": "L'adresse e-mail que vous avez saisie n'est associée à aucun compte. Vérifiez votre e-mail ou inscrivez-vous pour commencer.",
      "ES": "La dirección de correo electrónico que ingresó no está asociada con ninguna cuenta. Verifique su correo electrónico o regístrese para comenzar."
    },
    "An email with password-reset instructions is on its way. Check your inbox and your junk folder, then click the link within 1 hour to pick a new password.": {
      "EN": "An email with password-reset instructions is on its way. Check your inbox and your junk folder, then click the link within 1 hour to pick a new password.",
      "FR": "Un e-mail avec des instructions de réinitialisation du mot de passe est en route. Vérifiez votre boîte de réception et votre dossier de courrier indésirable, puis cliquez sur le lien dans l'heure pour choisir un nouveau mot de passe.",
      "ES": "Un correo electrónico con instrucciones para restablecer la contraseña está en camino. Verifique su bandeja de entrada y su carpeta de correo no deseado, luego haga clic en el enlace dentro de la hora para elegir una nueva contraseña."
    },
    "Link on its way!": {
      "EN": "Link on its way!",
      "FR": "Lien en route !",
      "ES": "¡Enlace en camino!"
    },
    "Password Reset": {
      "EN": "Password Reset",
      "FR": "Réinitialisation du Mot de Passe",
      "ES": "Restablecimiento de Contraseña"
    },
    "New password": {
      "EN": "New password",
      "FR": "Nouveau mot de passe",
      "ES": "Nueva contraseña"
    },
    "Repeat new password": {
      "EN": "Repeat new password",
      "FR": "Répéter le nouveau mot de passe",
      "ES": "Repetir nueva contraseña"
    },
    "Sorry, this link isn’t valid anymore. It may have expired or already been used—please try sending a new reset link.": {
      "EN": "Sorry, this link isn’t valid anymore. It may have expired or already been used—please try sending a new reset link.",
      "FR": "Désolé, ce lien n'est plus valide. Il a peut-être expiré ou a déjà été utilisé - veuillez essayer d'envoyer un nouveau lien de réinitialisation.",
      "ES": "Lo siento, este enlace ya no es válido. Puede que haya expirado o ya se haya utilizado; por favor, intenta enviar un nuevo enlace de restablecimiento."
    },
    "Sorry, the password reset link has expired. Please request a new one.": {
      "EN": "Sorry, the password reset link has expired. Please request a new one.",
      "FR": "Désolé, le lien de réinitialisation du mot de passe a expiré. Veuillez en demander un nouveau.",
      "ES": "Lo siento, el enlace de restablecimiento de contraseña ha expirado. Solicite uno nuevo."
    },
    "Your password has been reset successfully. You can now log in with your new credentials.": {
      "EN": "Your password has been reset successfully. You can now log in with your new credentials.",
      "FR": "Votre mot de passe a été réinitialisé avec succès. Vous pouvez maintenant vous connecter avec vos nouvelles informations d'identification.",
      "ES": "Su contraseña ha sido restablecida con éxito. Ahora puede iniciar sesión con sus nuevas credenciales."
    },
    "Password modified": {
      "EN": "Password modified",
      "FR": "Mot de passe modifié",
      "ES": "Contraseña modificada"
    },
    "You’ve arrived here because you clicked the password-reset link we sent to your email. Please choose a new password below.": {
      "EN": "You’ve arrived here because you clicked the password-reset link we sent to your email. Please choose a new password below.",
      "FR": "Vous êtes arrivé ici parce que vous avez cliqué sur le lien de réinitialisation du mot de passe que nous avons envoyé à votre e-mail. Veuillez choisir un nouveau mot de passe ci-dessous.",
      "ES": "Has llegado aquí porque hiciste clic en el enlace de restablecimiento de contraseña que enviamos a tu correo electrónico. Por favor, elige una nueva contraseña a continuación."
    },
  },
  "AuthReset": {
    "Password Reset": {
      "EN": "Password Reset",
      "FR": "Réinitialisation du Mot de Passe",
      "ES": "Restablecimiento de Contraseña"
    },
    "New password": {
      "EN": "New password",
      "FR": "Nouveau mot de passe",
      "ES": "Nueva contraseña"
    },
    "Repeat new password": {
      "EN": "Repeat new password",
      "FR": "Répéter le nouveau mot de passe",
      "ES": "Repetir nueva contraseña"
    },
    "Password modified": {
      "EN": "Password modified",
      "FR": "Mot de passe modifié",
      "ES": "Contraseña modificada"
    },
    "Your new password has been saved.": {
      "EN": "Your new password has been saved.",
      "FR": "Votre nouveau mot de passe a été enregistré.",
      "ES": "Su nueva contraseña ha sido guardada."
    }
  },
  "AuthPage": {
    "Authentification": {
      "EN": "Authentification",
      "FR": "Authentification",
      "ES": "Autenticación"
    },
    "This feature is not available yet.": {
      "EN": "This feature is not available yet.",
      "FR": "Cette fonctionnalité n'est pas encore disponible.",
      "ES": "Esta función aún no está disponible."
    },
    "Credentials Invalid: Please check your email and password and try again.": {
      "EN": "Credentials Invalid: Please check your email and password and try again.",
      "FR": "Identifiants invalides : Veuillez vérifier votre email et votre mot de passe et réessayer.",
      "ES": "Credenciales inválidas: Por favor, verifica tu correo electrónico y contraseña e intenta nuevamente."
    },
    "Account Locked: Please contact support for assistance.": {
      "EN": "Account Locked: Please contact support for assistance.",
      "FR": "Compte verrouillé : Veuillez contacter le support pour obtenir de l'aide.",
      "ES": "Cuenta bloqueada: Por favor, contacta con soporte para obtener ayuda."
    },
    "Account Pending: Please contact your representative for further information.": {
      "EN": "Account pending: Please contact your representative for further information.",
      "FR": "Compte en attente : Veuillez contacter votre représentant pour plus d'informations.",
      "ES": "Cuenta pendiente: Por favor, contacta con tu representante para más información."
    },
    "Password": {
      "EN": "Password",
      "FR": "Mot de passe",
      "ES": "Contraseña"
    },
    "Forgot your password?": {
      "EN": "Forgot your password?",
      "FR": "Oublié votre mot de passe?",
      "ES": "¿Olvidaste tu contraseña?"
    },
    "Sign in": {
      "EN": "Sign in",
      "FR": "Connexion",
      "ES": "Iniciar sesión"
    },
    "Email": {
      "EN": "Email",
      "FR": "Courriel",
      "ES": "Correo electrónico"
    },
    "Don't have an account?": {
      "EN": "Don't have an account?",
      "FR": "Pas de compte?",
      "ES": "¿No tengo una cuenta?"
    },
    "Sign up": {
      "EN": "Sign up",
      "FR": "Inscription",
      "ES": "Inscribirse"
    },
    "OR": {
      "EN": "OR",
      "FR": "OU",
      "ES": "O"
    },
    "Continue with ": {
      "EN": "Continue with ",
      "FR": "Continuer avec ",
      "ES": "Continua con "
    }
  },
  "AuthRedirect": {
    "Preparing account": {
      "EN": "Preparing account",
      "FR": "Préparation du compte",
      "ES": "Preparando la cuenta"
    }
  },
  "AuthFill": {
    "Complete the information": {
      "EN": "Complete the information",
      "FR": "Complétez les informations",
      "ES": "Complete la información"
    },  
    "To complete your account creation, kindly fill out the form below.": {
      "EN": "To complete your account creation, kindly fill out the form below.",
      "FR": "Pour finaliser la création de votre compte, veuillez remplir le formulaire ci-dessous.",
      "ES": "Para completar la creación de su cuenta, por favor complete el formulario a continuación."
    },
    "First name": {
      "EN": "First name",
      "FR": "Prénom",
      "ES": "Nombre"
    },
    "Last name": {
      "EN": "Last name",
      "FR": "Nom de famille",
      "ES": "Apellido"
    },
    "This field can't be empty.": {
      "EN": "This field can't be empty.",
      "FR": "Ce champ ne peut pas être vide.",
      "ES": "Este campo no puede estar vacío."
    },
    "Company name": {
      "EN": "Company name",
      "FR": "Nom de l'entreprise",
      "ES": "Nombre de la empresa"
    },
    "Temperature Unit": {
      "EN": "Temperature Unit",
      "FR": "Unité de température",
      "ES": "Unidad de temperatura"
    },
    "Language": {
      "EN": "Language",
      "FR": "Langue",
      "ES": "Idioma"
    },
    "Submit": {
      "EN": "Submit",
      "FR": "Envoyer",
      "ES": "Enviar"
    },
    "Cancel": {
      "EN": "Cancel",
      "FR": "Annuler",
      "ES": "Cancelar"
    }
  },
  "AuthSignup": {
    "Sign up": {
      "EN": "Sign up",
      "FR": "Inscription",
      "ES": "Inscribirse"
    },
    "Email": {
      "EN": "Email",
      "FR": "Courriel",
      "ES": "Correo electrónico"
    },
    "First name": {
      "EN": "First name",
      "FR": "Prénom",
      "ES": "Nombre"
    },
    "Last name": {
      "EN": "Last name",
      "FR": "Nom de famille",
      "ES": "Apellido"
    },
    "This field can't be empty.": {
      "EN": "This field can't be empty.",
      "FR": "Ce champ ne peut pas être vide.",
      "ES": "Este campo no puede estar vacío."
    },
    "This field has exceeded the character limit.": {
      "EN": "This field has exceeded the character limit.",
      "FR": "Ce champ a dépassé la limite de caractères.",
      "ES": "Este campo ha excedido el límite de caracteres."
    },
    "Company name": {
      "EN": "Company name",
      "FR": "Nom de l'entreprise",
      "ES": "Nombre de la empresa"
    },
    "Password": {
      "EN": "Password",
      "FR": "Mot de passe",
      "ES": "Contraseña"
    },
    "Repeat password": {
      "EN": "Repeat password",
      "FR": "Répéter le mot de passe",
      "ES": "Repetir contraseña"
    },
    "Submit": {
      "EN": "Submit",
      "FR": "Envoyer",
      "ES": "Enviar"
    },
    "Cancel": {
      "EN": "Cancel",
      "FR": "Annuler",
      "ES": "Cancelar"
    },
    "Email format is invalid.": {
      "EN": "Email format is invalid.",
      "FR": "Le format de l'email est invalide.",
      "ES": "El formato del correo electrónico es inválido."
    },
    "Do you really want to cancel the account creation?": {
      "EN": "Do you really want to cancel the account creation?",
      "FR": "Voulez-vous réellement annuler la création du compte ?",
      "ES": "¿Realmente desea cancelar la creación de la cuenta?"
    },
    "Insufficient characters in the field. (min. 8 characters)": {
      "EN": "Insufficient characters in the field. (min. 8 characters)",
      "FR": "Nombre de caractères insuffisant dans le champ. (min. 8 caractères)",
      "ES": "Número insuficiente de caracteres en el campo. (mínimo 8 caracteres)"
    },
    "Passwords must match.": {
      "EN": "Passwords must match.",
      "FR": "Les mots de passe doivent être identique.",
      "ES": "Las contraseñas deben coincidir."
    },
    "An account with this email already exists.": {
      "EN": "An account with this email already exists.",
      "FR": "Un compte avec cette adresse e-mail existe déjà.",
      "ES": "Ya existe una cuenta con este correo electrónico."
    },
    "Choose language": {
      "EN": "Choose language",
      "FR": "Choisir la langue",
      "ES": "Seleccionar idioma"
    },
    "Congratulations on successfully creating your account...": {
      "EN": "Congratulations on successfully creating your account! To complete the registration process, we have sent a verification email to your inbox.",
      "FR": "Félicitations pour la création de votre compte ! Pour finaliser le processus d'inscription, nous avons envoyé un e-mail de vérification dans votre boîte de réception.",
      "ES": "¡Felicitaciones por crear tu cuenta exitosamente! Para completar el proceso de registro, hemos enviado un correo electrónico de verificación a tu bandeja de entrada."
    },
    "Please check your email and follow the instructions...": {
      "EN": "Please check your email and follow the instructions provided to verify your email address. ",
      "FR": "Veuillez vérifier votre courrier électronique et suivre les instructions fournies pour vérifier votre adresse e-mail. ",
      "ES": "Por favor, revisa tu correo electrónico y sigue las instrucciones proporcionadas para verificar tu dirección de correo electrónico. "
    },
    "If you can't find the email, kindly check your spam or junk folder.": {
      "EN": "If you can't find the email, kindly check your spam or junk folder.",
      "FR": "Si vous ne trouvez pas l'e-mail, veuillez vérifier votre dossier de courrier indésirable ou spam.",
      "ES": "Si no encuentras el correo electrónico, por favor revisa tu carpeta de correo no deseado o spam."
    },
    "Once your email is verified, you'll...": {
      "EN": "Once your email is verified, you'll be able to log in to your account and enjoy all the benefits of our platform.",
      "FR": "Une fois votre adresse e-mail vérifiée, vous pourrez vous connecter à votre compte et profiter de tous les avantages de notre plateforme.",
      "ES": "Una vez verificado tu correo electrónico, podrás iniciar sesión en tu cuenta y disfrutar de todos los beneficios de nuestra plataforma."
    }
  },
  "AuthVerify": {
    "Email Verification": {
      "EN": "Email Verification",
      "FR": "Vérification de l'adresse courriel",
      "ES": "Verificación de correo electrónico"
    },
    "Congratulations! Your email address has...": {
      "EN": "Congratulations! Your email address has been successfully verified. You can now log in to your account and begin accessing the various features available.",
      "FR": "Félicitations ! Votre adresse e-mail a été vérifiée avec succès. Vous pouvez maintenant vous connecter à votre compte et commencer à accéder aux différentes fonctionnalités disponibles.",
      "ES": "¡Felicidades! Se ha verificado correctamente tu dirección de correo electrónico. Ahora puedes iniciar sesión en tu cuenta y comenzar a acceder a las diversas características disponibles."
    },
    "Please note that your account may need to be validated before you...": {
      "EN": "Please note that your account may need to be validated before you can proceed further. We appreciate your patience and will notify you once the validation process is complete.",
      "FR": "Veuillez noter que votre compte doit peut-être être validé avant de pouvoir continuer. Nous vous remercions de votre patience et nous vous informerons dès que le processus de validation sera terminé.",
      "ES": "Ten en cuenta que es posible que tu cuenta deba validarse antes de poder continuar. Agradecemos tu paciencia y te notificaremos una vez que el proceso de validación esté completo."
    }
  },
  "AuthToVerify": {
    "Email Verification Pending: Please check your mailbox...": {
      "EN": "Email Verification Pending: Please check your mailbox for the verification message. If you haven't received it, you can request another verification email.",
      "FR": "Vérification du courriel en attente : Veuillez vérifier votre boîte de réception pour le message de vérification. Si vous ne l'avez pas reçu, vous pouvez demander un autre courriel de vérification.",
      "ES": "Verificación de correo electrónico pendiente: Por favor, revisa tu buzón de correo para el mensaje de verificación. Si no lo has recibido, puedes solicitar otro correo electrónico de verificación."
    },
    "Email Verification": {
      "EN": "Email Verification",
      "FR": "Vérification de l'adresse courriel",
      "ES": "Verificación de correo electrónico"
    },
    "Resend Verification Email": {
      "EN": "Resend Verification Email",
      "FR": "Renvoyer le courriel de vérification",
      "ES": "Reenviar correo de verificación"
    },
    "Email Resend Limit...": {
      "EN": "Email Resend Limit: Please wait for 1 minute before attempting to send another verification email. Thank you for your understanding.",
      "FR": "Limite de renvoi de l'e-mail : Veuillez patienter pendant 1 minute avant de tenter d'envoyer un autre e-mail de vérification. Merci de votre compréhension.",
      "ES": "Límite de reenvío de correo electrónico: Por favor, espera 1 minuto antes de intentar enviar otro correo electrónico de verificación. Gracias por tu comprensión."
    },
    "Email Resend Limit...5": {
      "EN": "Email Resend Limit: Please wait for 5 minutes before attempting to send another verification email. Thank you for your understanding.",
      "FR": "Limite de renvoi de l'e-mail : Veuillez patienter pendant 5 minutes avant de tenter d'envoyer un autre e-mail de vérification. Merci de votre compréhension.",
      "ES": "Límite de reenvío de correo electrónico: Por favor, espera 5 minutos antes de intentar enviar otro correo electrónico de verificación. Gracias por tu comprensión."
    },
    "Verification Email Sent": {
      "EN": "Email sent",
      "FR": "Email de vérification envoyé",
      "ES": "Correo electrónico enviado"
    },
    "Verification Email Sent: We have sent...": {
      "EN": "Verification Email Sent: We have sent a verification email to your registered email address. Please check your inbox.",
      "FR": "Nous avons envoyé un email de vérification à votre adresse email enregistrée. Veuillez vérifier votre boîte de réception.",
      "ES": "Hemos enviado un correo electrónico de verificación a tu dirección de correo electrónico registrada. Por favor, revisa tu bandeja de entrada."
    }
  },
  "Validation": {
    "Email format is invalid.": {
      "EN": "Email format is invalid.",
      "FR": "Le format de l'email est invalide.",
      "ES": "El formato del correo electrónico es inválido."
    },
    "This field can't be empty.": {
      "EN": "This field can't be empty.",
      "FR": "Ce champ ne peut pas être vide.",
      "ES": "Este campo no puede estar vacío."
    },    
    "This field has exceeded the character limit.": {
      "EN": "This field has exceeded the character limit.",
      "FR": "Ce champ a dépassé la limite de caractères.",
      "ES": "Este campo ha excedido el límite de caracteres."
    },
    "Insufficient characters in the field.": {
      "EN": "Insufficient characters in the field.",
      "FR": "Caractères insuffisants dans le champ.",
      "ES": "Caracteres insuficientes en el campo."
    },
    "Values doesn't match.": {
      "EN": "Values doesn't match.",
      "FR": "Les valeurs ne correspondent pas.",
      "ES": "Los valores no coinciden."
    },
    "This field only accepts integers.": {
      "EN": "This field only accepts integers.",
      "FR": "Ce champ n'accepte que les entiers.",
      "ES": "Este campo solo acepta números enteros."
    },
    "This field only accepts numbers.": {
      "EN": "This field only accepts numbers.",
      "FR": "Ce champ n'accepte que des chiffres.",
      "ES": "Este campo solo acepta números."
    },
    "Value too high.": {
      "EN": "Value too high.",
      "FR": "Valeur trop élevée.",
      "ES": "Valor demasiado alto."
    },
    "Value too low.": {
      "EN": "Value too low.",
      "FR": "Valeur trop basse.",
      "ES": "Valor demasiado bajo."
    },
    "Value doesn't exist.": {
      "EN": "Value doesn't exist.",
      "FR": "La valeur n'existe pas.",
      "ES": "El valor no existe."
    },
    "Value already exists.": {
      "EN": "Value already exists.",
      "FR": "La valeur existe déjà.",
      "ES": "El valor ya existe."
    },
    "The label field must contain an English value.": {
      "EN": "The label field must contain an English value.",
      "FR": "Le champ d'étiquette doit contenir une valeur en anglais.",
      "ES": "El campo de etiqueta debe contener un valor en inglés."
    }
  },
  "HomePage": {
    "Welcome to the Innovair Solutions application...": {
      "EN": "Welcome to the Innovair Solutions application! Please utilize the top-left menu for navigation throughout our platform. Thank you for choosing Innovair Solutions.",
      "FR": "Bienvenue dans l'application Innovair Solutions ! Veuillez utiliser le menu en haut à gauche pour naviguer sur notre plateforme. Merci d'avoir choisi Innovair Solutions.",
      "ES": "¡Bienvenido/a a la aplicación de Innovair Solutions! Por favor, utiliza el menú en la parte superior izquierda para navegar en nuestra plataforma. Gracias por elegir Innovair Solutions."
    }
  },
  "Header": {
    "Submenu": {
      "EN": "Submenu",
      "FR": "Sous-menu",
      "ES": "Submenú"
    },
    "Return": {
      "EN": "Return",
      "FR": "Retour",
      "ES": "Volver"
    },
    "Account": {
      "EN": "Account",
      "FR": "Compte",
      "ES": "Cuenta"
    }
  },
  "VariableDesigner": {
    "Variable Designer": {
      "EN": "Variable Designer",
      "FR": "Concepteur de variable",
      "ES": "Diseñador de variables"
    },
    "Add in batch": {
      "EN": "Add in batch",
      "FR": "Ajouter en lot",
      "ES": "Añadir por lotes"
    },
    "Values to add": {
      "EN": "Values to add",
      "FR": "Valeurs à ajouter",
      "ES": "Valores a añadir"
    },
    "Error at line": {
      "EN": "Error at line",
      "FR": "Erreur à la ligne",
      "ES": "Error en la línea"
    },
    "Delete all": {
      "EN": "Delete all",
      "FR": "Tout supprimer",
      "ES": "Eliminar todo"
    }
  },
  "ProcessFile": {
    "Process Files": {
      "EN": "Process Files",
      "FR": "Fichiers de Processus",
      "ES": "Archivos del Proceso"
    },
    "Are you certain you wish to proceed...": {
      "EN": "Are you certain you wish to proceed with the deletion of this file? This action cannot be undone.",
      "FR": "Êtes-vous sûr(e) de vouloir procéder à la suppression de ce fichier ? Cette action est irréversible.",
      "ES": "¿Está seguro de que desea continuar con la eliminación de este archivo? Esta acción no se puede deshacer"
    },
    "Process File": {
      "EN": "Process File",
      "FR": "Fichier de Processus",
      "ES": "Archivo del Proceso"
    }
  },
  "T_ProcessFile": {
    "name": {
      "EN": "Name",
      "FR": "Nom",
      "ES": "Nombre"
    },
    "description": {
      "EN": "Description",
      "FR": "Description",
      "ES": "Descripción"
    },
    "type": {
      "EN": "Type",
      "FR": "Type",
      "ES": "Tipo"
    },
    "format": {
      "EN": "Format",
      "FR": "Format",
      "ES": "Formato"
    },
    "isActive": {
      "EN": "Active",
      "FR": "Actif",
      "ES": "Activo"
    },
    "label": {
      "EN": "Label",
      "FR": "Étiquette",
      "ES": "Etiqueta"
    },
    "file": {
      "EN": "File",
      "FR": "Fichier",
      "ES": "Archivo"
    },
    "Duplicate name": {
      "EN": "Duplicate name found, please use a unique name.",
      "FR": "Nom en double trouvé, veuillez utiliser un nom unique.",
      "ES": "Se ha encontrado un nombre duplicado, por favor use un nombre único."
    }
  },
  "ProductFile": {
    "Product Files": {
      "EN": "Product Files",
      "FR": "Fichiers Produit",
      "ES": "Archivos Producto"
    },
    "Are you certain you wish to proceed...": {
      "EN": "Are you certain you wish to proceed with the deletion of this file? This action cannot be undone.",
      "FR": "Êtes-vous sûr(e) de vouloir procéder à la suppression de ce fichier ? Cette action est irréversible.",
      "ES": "¿Está seguro de que desea continuar con la eliminación de este archivo? Esta acción no se puede deshacer"
    },
    "Are you certain you wish to proceed with product...": {
      "EN": "This file is used in {usedBy} product(s). Are you certain you wish to proceed with the deletion of this file? This action cannot be undone and the file will be removed from the product(s).",
      "FR": "Ce fichier est utilisé dans {usedBy} produit(s). Êtes-vous certain de vouloir procéder à la suppression de ce fichier ? Cette action est irréversible et le fichier sera supprimé du ou des produit(s).",
      "ES": "Este archivo se utiliza en {usedBy} producto(s). ¿Está seguro de que desea proceder con la eliminación de este archivo? Esta acción no se puede deshacer y el archivo será eliminado del o de los producto(s)."
    },
    "Product File": {
      "EN": "Product File",
      "FR": "Fichier Produit",
      "ES": "Archivo Producto"
    }
  },
  "T_ProductFile": {
    "name": {
      "EN": "Name",
      "FR": "Nom",
      "ES": "Nombre"
    },
    "description": {
      "EN": "Description",
      "FR": "Description",
      "ES": "Descripción"
    },
    "type": {
      "EN": "Type",
      "FR": "Type",
      "ES": "Tipo"
    },
    "format": {
      "EN": "Format",
      "FR": "Format",
      "ES": "Formato"
    },
    "isActive": {
      "EN": "Active",
      "FR": "Actif",
      "ES": "Activo"
    },
    "label": {
      "EN": "Label",
      "FR": "Étiquette",
      "ES": "Etiqueta"
    },
    "file": {
      "EN": "File",
      "FR": "Fichier",
      "ES": "Archivo"
    },
    "Duplicate name": {
      "EN": "Duplicate name found, please use a unique name.",
      "FR": "Nom en double trouvé, veuillez utiliser un nom unique.",
      "ES": "Se ha encontrado un nombre duplicado, por favor use un nombre único."
    },
    "tags": {
      "EN": "Tags",
      "FR": "Balises",
      "ES": "Etiquetas"
    }
  },
  "TagInput": {
    "Type and press Enter to add tags": {
      "EN": "Type and press Enter to add tags",
      "FR": "Tapez et appuyez sur Entrée pour ajouter des étiquettes",
      "ES": "Escriba y presione Enter para agregar etiquetas"
    }
  },
  "FileController": {
    "Browse": {
      "EN": "Browse",
      "FR": "Parcourir",
      "ES": "Examinar"
    },
    "Download": {
      "EN": "Download",
      "FR": "Télécharger",
      "ES": "Descargar"
    }
  },
  "Warranty": {
    "Serial number": {
      "EN": "Serial number",
      "FR": "Numéro de série",
      "ES": "Número de serie"
    },
    "Model": {
      "EN": "Model",
      "FR": "Modèle",
      "ES": "Modelo"
    },
    "Consult warranty information": {
      "EN": "Consult warranty information",
      "FR": "Consulter les informations sur la garantie",
      "ES": "Consultar la información de la garantía"
    },
    "Enter the serial number of your product": {
      "EN": "Enter the serial number of your product",
      "FR": "Entrez le numéro de série de votre produit",
      "ES": "Ingrese el número de serie de su producto"
    },
    "Search": {
      "EN": "Search",
      "FR": "Rechercher",
      "ES": "Buscar"
    },
    "Searching": {
      "EN": "Searching",
      "FR": "Recherche en cours",
      "ES": "Buscando"
    },
    "First name": {
      "EN": "First name",
      "FR": "Prénom",
      "ES": "Nombre"
    },
    "Last name": {
      "EN": "Last name",
      "FR": "Nom",
      "ES": "Apellido"
    },
    "Address": {
      "EN": "Address",
      "FR": "Adresse",
      "ES": "Dirección"
    },
    "Phone": {
      "EN": "Phone",
      "FR": "Téléphone",
      "ES": "Teléfono"
    },
    "Product serial number – Indoor unit": {
      "EN": "Product serial number – Indoor unit",
      "FR": "Numéro de série du produit – Unité intérieure",
      "ES": "Número de serie del producto – Unidad interior"
    },
    "Product serial number – Outdoor unit": {
      "EN": "Product serial number – Outdoor unit",
      "FR": "Numéro de série du produit – Unité extérieure",
      "ES": "Número de serie del producto – Unidad exterior"
    },
    "Indoor unit(s)": {
      "EN": "Indoor unit(s)",
      "FR": "Unité(s) intérieure(s)",
      "ES": "Unidad(es) interior(es)"
    },
    "Outdoor unit(s)": {
      "EN": "Outdoor unit(s)",
      "FR": "Unité(s) extérieure(s)",
      "ES": "Unidad(es) exterior(es)"
    },
    "Warranty": {
      "EN": "Warranty",
      "FR": "Garantie",
      "ES": "Garantía"
    },
    "Expiration": {
      "EN": "Expiration",
      "FR": "Expiration",
      "ES": "Expiración"
    },
    "Year(s) extended, part and labour": {
      "EN": "Year(s) extended, part and labour",
      "FR": "Année(s) prolongée(s), pièces et main-d'œuvre",
      "ES": "Año(s) extendido(s), partes y mano de obra"
    },
    "Warranty information is unavailable for the entered serial number.": {
      "EN": "Warranty information is unavailable for the entered serial number.",
      "FR": "Les informations sur la garantie de ce numéro de série saisi ne sont pas disponibles.",
      "ES": "La información de la garantía no está disponible para el número de serie ingresado."
    },
  },
  "ProcessDesigner": {
    "Sort the conditions": {
      "EN": "Sort conditions",
      "FR": "Trier les conditions",
      "ES": "Ordenar las condiciones"
    },
    "You have to create at least one step to test the process": {
      "EN": "You have to create at least one step to test the process",
      "FR": "Vous devez créer au moins une étape pour tester le processus",
      "ES": "Debe crear al menos un paso para probar el proceso"
    },
    "Select a process": {
      "EN": "Select a process",
      "FR": "Sélectionnez un processus",
      "ES": "Seleccione un proceso"
    },
    "Copy steps from another process": {
      "EN": "Copy steps from another process",
      "FR": "Copier des étapes d'un autre processus",
      "ES": "Copiar pasos de otro proceso"
    },
    "External Copy": {
      "EN": "External Copy",
      "FR": "Copie Externe",
      "ES": "Copia Externa"
    },
    "Group": {
      "EN": "Group",
      "FR": "Groupe",
      "ES": "Grupo"
    },
    "Remove this entry point": {
      "EN": "Remove this entry point",
      "FR": "Supprimer ce point d'entrée",
      "ES": "Eliminar este punto de entrada"
    },
    "This group cannot be deleted as it must be empty.": {
      "EN": "This group cannot be deleted as it must be empty.",
      "FR": "Ce groupe ne peut pas être supprimé car il doit être vide.",
      "ES": "Este grupo no se puede eliminar porque debe estar vacío."
    },
    "Entry point": {
      "EN": "Entry point",
      "FR": "Point d'entrée",
      "ES": "Punto de entrada"
    },
    "More options": {
      "EN": "More options",
      "FR": "Plus d'options",
      "ES": "Más opciones"
    },
    "Add a new group": {
      "EN": "Add a new group",
      "FR": "Ajouter un nouveau groupe",
      "ES": "Agregar un nuevo grupo"
    },
    "Are you sure you want to delete this condition?": {
      "EN": "Are you sure you want to delete this condition?",
      "FR": "Êtes-vous sûr(e) de vouloir supprimer cette condition ?",
      "ES": "¿Estás seguro(a) de querer eliminar esta condición?"
    },
    "Delete this condition": {
      "EN": "Delete this condition",
      "FR": "Supprimer cette condition",
      "ES": "Eliminar esta condición"
    },
    "Edit condition": {
      "EN": "Edit condition",
      "FR": "Modifier la condition",
      "ES": "Editar condición"
    },
    "Edit step": {
      "EN": "Edit step",
      "FR": "Modifier l'étape",
      "ES": "Editar paso"
    },
    "Edit group": {
      "EN": "Edit group",
      "FR": "Modifier le groupe",
      "ES": "Editar grupo"
    },
    "Open group": {
      "EN": "Open group",
      "FR": "Ouvrir le groupe",
      "ES": "Abrir grupo"
    },
    "Delete this group": {
      "EN": "Delete this group",
      "FR": "Supprimer ce groupe",
      "ES": "Eliminar este grupo"
    },    
    "Starting point": {
      "EN": "Starting point",
      "FR": "Point de départ",
      "ES": "Punto de partida"
    },
    "Start": {
      "EN": "Start",
      "FR": "Départ",
      "ES": "Inicio"
    },
    "Set as starting point": {
      "EN": "Set as starting point",
      "FR": "Définir comme point de départ",
      "ES": "Establecer como punto de partida"
    },
    "Are you sure you want to delete this entity?": {
      "EN": "Are you sure you want to delete this entity?",
      "FR": "Êtes-vous sûr(e) de vouloir supprimer cette entité ?",
      "ES": "¿Estás seguro(a) de querer eliminar esta entidad?"
    },
    "Delete this step": {
      "EN": "Delete this step",
      "FR": "Supprimer cette étape",
      "ES": "Eliminar este paso"
    },
    "Those two steps are already linked together.": {
      "EN": "Those two steps are already linked together.",
      "FR": "Ces deux étapes sont déjà liées entre elles.",
      "ES": "Esos dos pasos ya están enlazados."
    },
    "Link with another step": {
      "EN": "Link with another step",
      "FR": "Lier avec une autre étape",
      "ES": "Enlazar con otro paso"
    },
    "To create a new step, either...": {
      "EN": "To create a new step, either click on the top upper left 'Add Step' button or right-click in this zone and choose Add a new step.",
      "FR": "Pour créer une nouvelle étape, cliquez sur le bouton 'Ajouter une étape' en haut à gauche ou faites un clic droit dans cette zone et choisissez Ajouter une nouvelle étape.",
      "ES": "Para crear un nuevo paso, haz clic en el botón 'Agregar paso' en la parte superior izquierda o haz clic derecho en esta zona y elige Agregar un nuevo paso."
    },
    "Before publishing, please save your process. Would you like to save and proceed?":{
      "EN": "Before publishing, please save your process. Would you like to save and proceed?",
      "FR": "Avant de publier, veuillez enregistrer votre processus. Souhaitez-vous enregistrer et continuer ?",
      "ES": "Antes de publicar, por favor guarda tu proceso. ¿Te gustaría guardar y proceder?"
    },
    "Process": {
      "EN": "Process",
      "FR": "Processus",
      "ES": "Proceso"
    },
    "Publish": {
      "EN": "Publish",
      "FR": "Publier",
      "ES": "Publicar"
    },
    "Previous": {
      "EN": "Previous",
      "FR": "Précédent",
      "ES": "Anterior"
    },
    "Home": {
      "EN": "Home",
      "FR": "Accueil",
      "ES": "Inicio"
    },
    "Add Component": {
      "EN": "Add Component",
      "FR": "Ajouter un composant",
      "ES": "Agregar Componente"
    },
    "Settings": {
      "EN": "Settings",
      "FR": "Paramètres",
      "ES": "Configuración"
    },
    "Step title": {
      "EN": "Step title",
      "FR": "Titre de l'étape",
      "ES": "Título del paso"
    },
    "This step cannot be deleted as it has dependent sub-steps.": {
      "EN": "This step cannot be deleted as it has dependent sub-steps.",
      "FR": "Cette étape ne peut pas être supprimée car elle a des sous-étapes dépendantes.",
      "ES": "Esta etapa no se puede eliminar ya que tiene sub-etapas dependientes."
    },
    "This step cannot be removed because it is utilized within a condition.": {
      "EN": "This step cannot be removed because it is utilized within a condition.",
      "FR": "Cette étape ne peut pas être supprimée car elle est utilisée dans une condition.",
      "ES": "Este paso no se puede eliminar porque se utiliza dentro de una condición."
    },
    "Test this process": {
      "EN": "Test this process",
      "FR": "Tester ce processus",
      "ES": "Probar este proceso"
    },
    "Flowchart view": {
      "EN": "Flowchart view",
      "FR": "Vue organigramme",
      "ES": "Vista de diagrama de flujo"
    },
    "Hierarchy view": {
      "EN": "Hierarchy view",
      "FR": "Vue hiérarchique",
      "ES": "Vista de jerarquía"
    },
    "Step": {
      "EN": "Step",
      "FR": "Étape",
      "ES": "Paso"
    },
    "Please select every step that you wish...": {
      "EN": "Please select every step that you wish to copy by clicking on them. When finished, press the 'Confirm' button at the bottom.",
      "FR": "Veuillez sélectionner chaque étape que vous souhaitez copier en cliquant dessus. Lorsque vous avez terminé, appuyez sur le bouton 'Confirmer' en bas.",
      "ES": "Seleccione cada paso que desee copiar haciendo clic en ellos. Cuando haya terminado, presione el botón 'Confirmar' en la parte inferior."
    },
    "Select Steps": {
      "EN": "Select Steps",
      "FR": "Sélectionner les étapes",
      "ES": "Seleccionar pasos"
    },
    "Selected Steps": {
      "EN": "Selected Steps",
      "FR": "Étapes sélectionnées",
      "ES": "Pasos seleccionados"
    },
    "Confirm selected steps": {
      "EN": "Confirm selected steps",
      "FR": "Confirmer les étapes sélectionnées",
      "ES": "Confirmar los pasos seleccionados"
    },
    "Please confirm the new names of the duplicated steps": {
      "EN": "Please confirm the new names of the duplicated steps",
      "FR": "Veuillez confirmer les nouveaux noms des étapes dupliquées",
      "ES": "Por favor, confirme los nuevos nombres de los pasos duplicados"
    },
    "Add a new step": {
      "EN": "Add a new step",
      "FR": "Ajouter une nouvelle étape",
      "ES": "Agregar un nuevo paso"
    }
  },
  "ProcessDesignerNavigationButton": {
    "Next": {
      "EN": "Action: Go to next step",
      "FR": "Action : Aller à l'étape suivante",
      "ES": "Acción: Ir al siguiente paso"
    },
    "Home": {
      "EN": "Action: Go Home",
      "FR": "Action : Retour à l'accueil",
      "ES": "Acción: Ir a inicio"
    },
    "Back": {
      "EN": "Action: Go back",
      "FR": "Action : Retour",
      "ES": "Acción: Volver atrás"
    }  
  },
  "AdminProcessPage": {
    "Troubleshoot Process": {
      "EN": "Troubleshoot Process",
      "FR": "Processus de dépannage",
      "ES": "Proceso de solución de problemas"
    }
  },
  "T_Process": {
    "code": {
      "EN": "Code",
      "FR": "Code",
      "ES": "Código"
    },
    "description": {
      "EN": "Description",
      "FR": "Description",
      "ES": "Descripción"
    },
    "brand": {
      "EN": "Brand",
      "FR": "Marque",
      "ES": "Marca"
    },
    "status": {
      "EN": "Status",
      "FR": "Statut",
      "ES": "Estado"
    },
    "Modified": {
      "EN": "Modified",
      "FR": "Modifié",
      "ES": "Modificado"
    },
    "isTemplate": {
      "EN": "Template",
      "FR": "Modèle",
      "ES": "Plantilla"
    },
    "isActive": {
      "EN": "Active",
      "FR": "Actif",
      "ES": "Activo"
    },
    "usedByProduct": {
      "EN": "Used by",
      "FR": "Utilisé par",
      "ES": "Usado por"
    },
    "Duplicate Code": {
      "EN": "Duplicate code found, please use a unique code.",
      "FR": "Code en double trouvé, veuillez utiliser un code unique.",
      "ES": "Código duplicado encontrado, por favor use un código único."
    },
    "Product Type Does Not Exist": {
      "EN": "Product type does not exist.",
      "FR": "Le type de produit n'existe pas.",
      "ES": "El tipo de producto no existe."
    }
  },
  "AdminProcessPublish": {
    "Publish": {
      "EN": "Publish",
      "FR": "Publier",
      "ES": "Publicar"
    },
    "Current Version": {
      "EN": "Current Version",
      "FR": "Version actuelle",
      "ES": "Versión actual"
    },
    "Published Version": {
      "EN": "Published Version",
      "FR": "Version publiée",
      "ES": "Versión publicada"
    },
    "Not Published": {
      "EN": "Not Published",
      "FR": "Non publié",
      "ES": "No publicado"
    },
    "Successful publication of the process": {
      "EN": "Successful publication of the process",
      "FR": "Publication réussie du processus",
      "ES": "Publicación exitosa del proceso"
    },
    "The process has been successfully published.": {
      "EN": "The process has been successfully published.",
      "FR": "Le processus a été publié avec succès.",
      "ES": "El proceso se ha publicado correctamente."
    },
    "Process Published": {
      "EN": "Process Published",
      "FR": "Processus publié",
      "ES": "Proceso publicado"
    }
  },
  "AdminProcessModal": {
    "Process Template": {
      "EN": "Process",
      "FR": "Processus",
      "ES": "Proceso"
    },
    "You have to save your template...": {
      "EN": "You have to save your template before going in the designer. Do you want to continue?",
      "FR": "Vous devez enregistrer votre modèle avant de passer à l'éditeur. Voulez-vous continuer ?",
      "ES": "Debe guardar su plantilla antes de ingresar al diseñador. ¿Desea continuar?"
    },
    "Are you certain you wish to proceed...": {
      "EN": "Are you certain you wish to proceed with the deletion of this process? This action cannot be undone.",
      "FR": "Êtes-vous sûr(e) de vouloir procéder à la suppression de ce processus ? Cette action ne peut pas être annulée.",
      "ES": "¿Estás seguro(a) de que deseas proceder con la eliminación de este proceso? Esta acción no se puede deshacer."
    }
  },
  "ProcessDesignerItem": {
    "Edit": {
      "EN": "Edit",
      "FR": "Modifier",
      "ES": "Editar"
    },
    "Add Step": {
      "EN": "Add Step",
      "FR": "Ajouter une étape",
      "ES": "Agregar paso"
    },
    "Conditions Order": {
      "EN": "Conditions order",
      "FR": "Ordre des conditions",
      "ES": "Orden de las condiciones"
    }
  },
  "ProcessDesignerToolbarModal":{
    "Add Component": {
      "EN": "Add Component",
      "FR": "Ajouter un composant",
      "ES": "Agregar Componente"
    }   
  },
  "ProcessDesignerDetail": {
    "Are you sure you want to delete this component": {
      "EN": "Are you sure you want to delete this component?",
      "FR": "Êtes-vous sûr de vouloir supprimer ce composant ?",
      "ES": "¿Estás seguro de que deseas eliminar este componente?"
    },
    "Navigation": {
      "EN": "Navigation",
      "FR": "Navigation",
      "ES": "Navegación"
    },
    "Back": {
      "EN": "Back",
      "FR": "Retour",
      "ES": "Atrás"
    },
    "Next": {
      "EN": "Next",
      "FR": "Suivant",
      "ES": "Siguiente"
    },
    "Home": {
      "EN": "Home",
      "FR": "Accueil",
      "ES": "Inicio"
    }
  },
  "ProcessDesignerSchema": {
    "Please select a template...": {
      "EN": "Please select a template or an existing step as the foundation for your new step",
      "FR": "Veuillez sélectionner un modèle ou une étape existante comme base pour votre nouvelle étape",
      "ES": "Por favor, selecciona una plantilla o un paso existente como base para tu nuevo paso"
    },
    "Step Templates": {
      "EN": "Step Templates",
      "FR": "Modèles d'étapes",
      "ES": "Plantillas de pasos"
    },
    "Existing Steps": {
      "EN": "Existing Steps",
      "FR": "Étapes existantes",
      "ES": "Pasos existentes"
    },
    "Select Multiple": {
      "EN": "Select Multiple",
      "FR": "Sélection multiple",
      "ES": "Selección múltiple"
    },
    "Select multiple steps in this process to copy": {
      "EN": "Select multiple steps in this process to copy",
      "FR": "Sélectionnez plusieurs étapes dans ce processus à copier",
      "ES": "Seleccione múltiples pasos en este proceso para copiar"
    },
  },
  "ComponentEntity": {
    "Superheat": {
      "EN": "Superheat",
      "FR": "Surchauffe",
      "ES": "Sobrecalentamiento"
    },
    "Temperature": {
      "EN": "Suction tube temperature (gas)",
      "FR": "Température du tube d'aspiration (gaz)",
      "ES": "Temperatura del tubo de succión (gas)"
    },
    "Pressure": {
      "EN": "Pressure of the refrigerant in the suction (gas) line",
      "FR": "Pression du réfrigérant dans la ligne d'aspiration (gaz)",
      "ES": "Presión del refrigerante en la línea de succión (gas)"
    },
    "Edit Component": {
      "EN": "Edit Component",
      "FR": "Modifier le composant",
      "ES": "Editar Componente"
    },
    "Move Up Component": {
      "EN": "Move Up Component",
      "FR": "Déplacer vers le haut le composant",
      "ES": "Mover el componente hacia arriba"
    },
    "Move Down Component": {
      "EN": "Move Down Component",
      "FR": "Déplacer vers le bas le composant",
      "ES": "Mover el componente hacia abajo"
    },
    "Add a new component before this": {
      "EN": "Add a new component before this",
      "FR": "Ajouter un nouveau composant avant celui-ci",
      "ES": "Agregar un nuevo componente antes de este"
    },
    "Delete this component": {
      "EN": "Delete this component",
      "FR": "Supprimer ce composant",
      "ES": "Eliminar este componente"
    },
    "For accurate diagnosis, please provide your error light code": {
      "EN": "For accurate diagnosis, please provide your error light code",
      "FR": "Pour un diagnostic précis, veuillez fournir le code de votre voyant d'erreur",
      "ES": "Para un diagnóstico preciso, por favor proporciona tu código de luz de error"
    },
    "Light off": {
      "EN": "Light off",
      "FR": "Lumière éteinte",
      "ES": "Luz apagada"
    },
    "Light on": {
      "EN": "Light on",
      "FR": "Lumière allumée",
      "ES": "Luz encendida"
    },
    "Flashing light": {
      "EN": "Flashing light",
      "FR": "Lumière clignotante",
      "ES": "Luz intermitente"
    },
    "Legend": {
      "EN": "Legend",
      "FR": "Légende",
      "ES": "Leyenda"
    },
    "Choose the light status": {
      "EN": "Choose the light status",
      "FR": "Choisissez l'état de la lumière",
      "ES": "Elige el estado de la luz"
    },
  },
  "ProcessDesignerModal": {
    "Temperature unit": {
      "EN": "Temperature unit",
      "FR": "Unité de température",
      "ES": "Unidad de temperatura"
    },
    "Select file": {
      "EN": "Select file",
      "FR": "Sélectionner un fichier",
      "ES": "Seleccionar archivo"
    },
    "Edit Component": {
      "EN": "Edit Component",
      "FR": "Modifier le composant",
      "ES": "Editar Componente"
    },   
    "Name": {
      "EN": "Name",
      "FR": "Nom",
      "ES": "Nombre"
    },
    "Text": {
      "EN": "Text",
      "FR": "Texte",
      "ES": "Texto"
    },
    "Style": {
      "EN": "Style",
      "FR": "Style",
      "ES": "Estilo"
    },
    "The component name already exists": {
      "EN": "The component name already exists",
      "FR": "Le nom du composant existe déjà",
      "ES": "El nombre del componente ya existe"
    },
    "Label": {
      "EN": "Label",
      "FR": "Étiquette",
      "ES": "Etiqueta"
    },
    "Label Style": {
      "EN": "Label Style",
      "FR": "Style d'étiquette",
      "ES": "Estilo de etiqueta"
    },
    "Input Validation": {
      "EN": "Input Validation",
      "FR": "Validation de saisie",
      "ES": "Validación de entrada"
    },
    "Input Style": {
      "EN": "Input Style",
      "FR": "Style de saisie",
      "ES": "Estilo de entrada"
    },
    "Option List": {
      "EN": "Option List",
      "FR": "Liste d'options",
      "ES": "Lista de opciones"
    },
    "Option Style": {
      "EN": "Option Style",
      "FR": "Style des options",
      "ES": "Estilo de opción"
    },
    "Action": {
      "EN": "Action",
      "FR": "Action",
      "ES": "Acción"
    },
    "Number of light": {
      "EN": "Number of light",
      "FR": "Nombre de lumières",
      "ES": "Número de luces"
    },
    "File": {
      "EN": "File",
      "FR": "Fichier",
      "ES": "Archivo"
    }
  },
  "LabelInput": {
    "Instant Translation": {
      "EN": "Instant Translation",
      "FR": "Traduction Instantanée",
      "ES": "Traducción Instantánea"
    },
    "Display": {
      "EN": "Display",
      "FR": "Afficher",
      "ES": "Mostrar"
    },
    "Edit": {
      "EN": "Edit",
      "FR": "Modifier",
      "ES": "Editar"
    },
    "Autofill with value of field": {
      "EN": "Autofill with value of field : ",
      "FR": "Remplissage automatique avec la valeur du champ : ",
      "ES": "Autocompletar con el valor del campo : "
    }
  },
  "StyleInput": {
    "Text Size": {
      "EN": "Text size",
      "FR": "Taille du texte",
      "ES": "Tamaño del texto"
    },
    "Text Alignment": {
      "EN": "Text alignment",
      "FR": "Alignement du texte",
      "ES": "Alineación del texto"
    },
    "Bold": {
      "EN": "Bold",
      "FR": "Gras",
      "ES": "Negrita"
    },
    "Underline": {
      "EN": "Underline",
      "FR": "Souligner",
      "ES": "Subrayado"
    },
    "Example text to test the styling": {
      "EN": "Example text",
      "FR": "Texte exemple",
      "ES": "Texto de ejemplo"
    },
    "Center": {
      "EN": "Center",
      "FR": "Centre",
      "ES": "Centro"
    },
    "Left": {
      "EN": "Left",
      "FR": "Gauche",
      "ES": "Izquierda"
    },
    "Right": {
      "EN": "Right",
      "FR": "Droit",
      "ES": "Derecha"
    },
    "Width": {
      "EN": "Width",
      "FR": "Largeur",
      "ES": "Ancho"
    },
    "Height": {
      "EN": "Height",
      "FR": "Hauteur",
      "ES": "Altura"
    },
    "Background Color": {
      "EN": "Background color",
      "FR": "Couleur d'arrière-plan",
      "ES": "Color de fondo"
    },
    "Color": {
      "EN": "Color",
      "FR": "Couleur",
      "ES": "Color"
    } ,
    "Blue": {
      "EN": "Blue",
      "FR": "Bleu",
      "ES": "Azul"
    },
    "Black": {
      "EN": "Black",
      "FR": "Noir",
      "ES": "Negro"
    },
    "Grey": {
      "EN": "Grey",
      "FR": "Gris",
      "ES": "Gris"
    },
    "White": {
      "EN": "White",
      "FR": "Blanc",
      "ES": "Blanco"
    },
    "Red": {
      "EN": "Red",
      "FR": "Rouge",
      "ES": "Rojo"
    }
  },
  "ValidationInput": {
    "Display": {
      "EN": "Display",
      "FR": "Afficher",
      "ES": "Mostrar"
    },
    "Edit": {
      "EN": "Edit",
      "FR": "Modifier",
      "ES": "Editar"
    },
    "Can't be empty": {
      "EN": "Can't be empty",
      "FR": "Ne peut pas être vide",
      "ES": "No puede estar vacío"
    },
    "Maximum length": {
      "EN": "Maximum length",
      "FR": "Longueur maximale",
      "ES": "Longitud máxima"
    },
    "Integer numbers only": {
      "EN": "Integer numbers only",
      "FR": "Nombres entiers seulement",
      "ES": "Solo números enteros"
    },
    "Minimum length": {
      "EN": "Minimum length",
      "FR": "Longueur minimale",
      "ES": "Longitud mínima"
    },
    "Maximum value": {
      "EN": "Maximum value",
      "FR": "Valeur maximale",
      "ES": "Valor máximo"
    },
    "Minimum value": {
      "EN": "Minimum value",
      "FR": "Valeur minimale",
      "ES": "Valor mínimo"
    },
    "Numbers only": {
      "EN": "Numbers only",
      "FR": "Nombres uniquement",
      "ES": "Solo números"
    }
  },
  "OptionInput": {
    "Yes / No": {
      "EN": "Yes / No",
      "FR": "Oui / Non",
      "ES": "Sí / No"
    },
    "Set Yes / No Options": {
      "EN": "Set Yes / No Options",
      "FR": "Définir les options Oui / Non",
      "ES": "Configurar opciones Sí / No"
    },
    "Value": {
      "EN": "Value",
      "FR": "Valeur",
      "ES": "Valor"
    },
    "Label": {
      "EN": "Label",
      "FR": "Étiquette",
      "ES": "Etiqueta"
    },
    "Delete Option": {
      "EN": "Delete option",
      "FR": "Supprimer l'option",
      "ES": "Eliminar opción"
    },
    "Move Up Option": {
      "EN": "Move up option",
      "FR": "Déplacer l'option vers le haut",
      "ES": "Mover la opción hacia arriba"
    },
    "Move Down Option": {
      "EN": "Move down option",
      "FR": "Déplacer l'option vers le bas",
      "ES": "Mover la opción hacia abajo"
    },
    "Delete this option?": {
      "EN": "Delete this option?",
      "FR": "Supprimer cette option ?",
      "ES": "¿Eliminar esta opción?"
    },
    "Add an option": {
      "EN": "Add an option",
      "FR": "Ajouter une option",
      "ES": "Agregar una opción"
    }
  },
  "ListFilter": {
    "like": {
      "EN": "contain",
      "FR": "contient",
      "ES": "como"
    },
    "notlike": {
      "EN": "not contain",
      "FR": "ne contient pas",
      "ES": "no contiene"
    },
    "equal": {
      "EN": "equal",
      "FR": "égal",
      "ES": "igual"
    },
    "different": {
      "EN": "different",
      "FR": "différent",
      "ES": "diferente"
    },
    "greater than": {
      "EN": "greater than",
      "FR": "plus grand",
      "ES": "mayor que"
    },
    "lesser than": {
      "EN": "lesser than",
      "FR": "plus petit",
      "ES": "menos que"
    },
    "Filters": {
      "EN": "Filters",
      "FR": "Filtres",
      "ES": "Filtros"
    },
    "Clear": {
      "EN": "Clear",
      "FR": "Effacer",
      "ES": "Borrar"
    },
    "Apply": {
      "EN": "Apply",
      "FR": "Appliquer",
      "ES": "Aplicar"
    },
    "Close": {
      "EN": "Close",
      "FR": "Fermer",
      "ES": "Cerrar"
    }
  },
  "T_Variable": {
    "name": {
      "EN": "Name",
      "FR": "Nom",
      "ES": "Nombre"
    },
    "description": {
      "EN": "Description",
      "FR": "Description",
      "ES": "Descripción"
    },
    "variableTypeLabel": {
      "EN": "Type",
      "FR": "Type",
      "ES": "Tipo"
    },
    "dataToDisplay": {
      "EN": "Value",
      "FR": "Valeur",
      "ES": "Valor"
    },
    "isParameter": {
      "EN": "Parameter",
      "FR": "Paramètre",
      "ES": "Parámetro"     
    },
    "parameterOption": {
      "EN": "Parameter Options",
      "FR": "Options du paramètres",
      "ES": "Opciones de parámetros"
    },
    "order": {
      "EN": "Display order",
      "FR": "Ordre d'affichage",
      "ES": "Orden de visualización"
    },
  },
  "VariableDesignerModal": {
    "Duplicate": {
      "EN": "Duplicate",
      "FR": "Dupliquer",
      "ES": "Duplicar"
    },
    "Delete all": {
      "EN": "Delete all",
      "FR": "Tout supprimer",
      "ES": "Eliminar todo"
    },
    "Are you sure you want to delete all the rows?": {
      "EN": "Are you sure you want to delete all the rows?",
      "FR": "Êtes-vous sûr de vouloir supprimer toutes les lignes ?",
      "ES": "¿Está seguro de que desea eliminar todas las filas?"
    },
    "Variable": {
      "EN": "Variable",
      "FR": "Variable",
      "ES": "Variable"
    },
    "Table Variable": {
      "EN": "Table Variable",
      "FR": "Variable Tableau",
      "ES": "Variable Tabla"
    },
    "Number of columns": {
      "EN": "Number of columns",
      "FR": "Nombre de colonnes",
      "ES": "Número de columnas"
    },
    "Column titles": {
      "EN": "Column titles",
      "FR": "Titre de colonnes",
      "ES": "Títulos de columnas"
    },
    "Row": {
      "EN": "Row",
      "FR": "Ligne",
      "ES": "Fila"
    },
    "Add row": {
      "EN": "Add row",
      "FR": "Ajouter une ligne",
      "ES": "Agregar fila"
    },
    "Remove row": {
      "EN": "Remove row",
      "FR": "Supprimer la ligne",
      "ES": "Eliminar fila"
    },
    "Are you sure you want to delete this row?": {
      "EN": "Are you sure you want to delete this row?",
      "FR": "Êtes-vous sûr de vouloir supprimer cette ligne ?",
      "ES": "¿Está seguro de que desea eliminar esta fila?"
    },
    "Temperature unit": {
      "EN": "Temperature unit",
      "FR": "Unité de température",
      "ES": "Unidad de temperatura"
    },
    "Sensor variable": {
      "EN": "Sensor variable",
      "FR": "Variable de capteur",
      "ES": "Variable del sensor"
    },
    "Tolerance": {
      "EN": "Tolerance",
      "FR": "Tolérance",
      "ES": "Tolerancia"
    }
  },
  "InitDesigner": {
    "Are you sure you want to delete this script?": {
      "EN": "Are you sure you want to delete this script?",
      "FR": "Êtes-vous sûr de vouloir supprimer ce script ?",
      "ES": "¿Está seguro de que desea eliminar este script?"
    },
    "Hide this script content": {
      "EN": "Hide this script content",
      "FR": "Masquer le contenu de ce script",
      "ES": "Ocultar el contenido de este script"
    },
    "Display this script content": {
      "EN": "Display this script content",
      "FR": "Afficher le contenu de ce script",
      "ES": "Mostrar el contenido de este script"
    },
    "assign": {
      "EN": "Assign value",
      "FR": "Attribuer la valeur",
      "ES": "Asignar valor"
    },
    "Delete this action": {
      "EN": "Delete this action",
      "FR": "Supprimer cette action",
      "ES": "Eliminar esta acción"
    },
    "Duplicate this script": {
      "EN": "Duplicate this script",
      "FR": "Dupliquer ce script",
      "ES": "Duplicar este script"
    },
    "Move up this script": {
      "EN": "Move up this script",
      "FR": "Monter ce script",
      "ES": "Subir este script"
    },
    "Move down this script": {
      "EN": "Move down this script",
      "FR": "Descendre ce script",
      "ES": "Bajar este script"
    },
    "Delete this script": {
      "EN": "Delete this script",
      "FR": "Supprimer ce script",
      "ES": "Eliminar este script"
    },
    "Add an action": {
      "EN": "Add an action",
      "FR": "Ajouter une action",
      "ES": "Agregar una acción"
    },
    "Action(s)": {
      "EN": "Action(s)",
      "FR": "Action(s)",
      "ES": "Acción(es)"
    },
    "Script": {
      "EN": "Script",
      "FR": "Script",
      "ES": "Script"
    },
    "Condition(s)": {
      "EN": "Condition(s)",
      "FR": "Condition(s)",
      "ES": "Condición(es)"
    },
    "This variable is a parameter": {
      "EN": "This variable is a parameter",
      "FR": "Cette variable est un paramètre",
      "ES": "Esta variable es un parámetro"
    },
    "Delete this condition": {
      "EN": "Delete this condition",
      "FR": "Supprimer cette condition",
      "ES": "Eliminar esta condición"
    },
    "Choose a variable": {
      "EN": "Choose a variable",
      "FR": "Choisissez une variable",
      "ES": "Elija una variable"
    },
    "Initialization script designer": {
      "EN": "Initialization script designer",
      "FR": "Concepteur de script d'initialisation",
      "ES": "Diseñador de script de inicialización"
    },
    "Initialization script": {
      "EN": "Initialization script",
      "FR": "Script d'initialisation",
      "ES": "Script de inicialización"
    },
    "Active": {
      "EN": "Active",
      "FR": "Actif",
      "ES": "Activo"
    },
    "Scripts": {
      "EN": "Scripts",
      "FR": "Scripts",
      "ES": "Scripts"
    },
    "Add script": {
      "EN": "Add script",
      "FR": "Ajouter un script",
      "ES": "Agregar un script"
    },
    "Add condition": {
      "EN": "Add condition",
      "FR": "Ajouter une condition",
      "ES": "Agregar una condición"
    }
  },
  "ConditionDesigner": {
    "Duplicate": {
      "EN": "Duplicate",
      "FR": "Dupliquer",
      "ES": "Duplicar"
    },
    "Are you sure you want to duplicate the...": {
      "EN": "Are you sure you want to duplicate the condition(s) of this group into a new group?",
      "FR": "Êtes-vous sûr de vouloir dupliquer la/les condition(s) de ce groupe dans un nouveau groupe ?",
      "ES": "¿Está seguro de que desea duplicar la(s) condición(es) de este grupo en un nuevo grupo?"
    },
    "Duplicate in another group": {
      "EN": "Duplicate in another group",
      "FR": "Dupliquer dans un autre groupe",
      "ES": "Duplicar en otro grupo"
    },
    "Add a global variable": {
      "EN": "Add a global variable",
      "FR": "Ajouter une variable globale",
      "ES": "Agregar una variable global"
    },
    "Sort your conditions": {
      "EN": "Sort your conditions",
      "FR": "Triez vos conditions",
      "ES": "Ordena tus condiciones"
    },
    "Condition order": {
      "EN": "Condition order",
      "FR": "Ordre des conditions",
      "ES": "Orden de la condición"
    },
    "Resistance": {
      "EN": "Resistance",
      "FR": "Résistance",
      "ES": "Resistencia"
    },
    "Edit the error code": {
      "EN": "Edit the error code",
      "FR": "Modifier le code d'erreur",
      "ES": "Editar el código de error"
    },
    "Condition(s)": {
      "EN": "Condition(s)",
      "FR": "Condition(s)",
      "ES": "Condición(es)"
    },
    "Condition Designer": {
      "EN": "Condition Designer",
      "FR": "Concepteur de Conditions",
      "ES": "Diseñador de Condiciones"
    },
    "literal": {
      "EN": "Literal",
      "FR": "Littéral",
      "ES": "Literal"
    },
    "userVariable": {
      "EN": "User variable",
      "FR": "Variable d'utilisateur",
      "ES": "Variable de usuario"
    },
    "globalVariable": {
      "EN": "Global variable",
      "FR": "Variable globale",
      "ES": "Variable global"
    },
    "tableVariable": {
      "EN": "Table Variable",
      "FR": "Variable de Table",
      "ES": "Variable de Tabla"
    },
    "formula": {
      "EN": "Formula",
      "FR": "Formule",
      "ES": "Fórmula"
    },
    "There is an error in the formula": {
      "EN": "There is an error in the formula.",
      "FR": "Il y a une erreur dans la formule.",
      "ES": "Hay un error en la fórmula."
    },
    "Add a variable": {
      "EN": "Add a variable",
      "FR": "Ajouter une variable",
      "ES": "Agregar una variable"
    },
    "Test the formula": {
      "EN": "Test the formula",
      "FR": "Tester la formule",
      "ES": "Probar la fórmula"
    },
    "Formula is valid.": {
      "EN": "Formula is valid.",
      "FR": "La formule est valide.",
      "ES": "La fórmula es válida."
    },
    "Choose a value": {
      "EN": "Choose a value",
      "FR": "Choisissez une valeur",
      "ES": "Elija un valor"
    },
    "Choose the variable type": {
      "EN": "Choose the variable type",
      "FR": "Choisissez le type de variable",
      "ES": "Elija el tipo de variable"
    },
    "Choose a variable": {
      "EN": "Choose a variable",
      "FR": "Choisissez une variable",
      "ES": "Elija una variable"
    },
    "Input a value": {
      "EN": "Input a value",
      "FR": "Entrez une valeur",
      "ES": "Ingrese un valor"
    },
    "Edit the formula": {
      "EN": "Edit the formula",
      "FR": "Modifier la formule",
      "ES": "Editar la fórmula"
    },
    "Select type": {
      "EN": "Select type",
      "FR": "Sélectionnez le type",
      "ES": "Seleccione el tipo"
    },
    "Select operator": {
      "EN": "Select operator",
      "FR": "Sélectionnez l'opérateur",
      "ES": "Seleccione el operador"
    },
    "eq": {
      "EN": "equal",
      "FR": "égal",
      "ES": "igual"
    },
    "ne": {
      "EN": "does not equal",
      "FR": "n'est pas égal",
      "ES": "no es igual"
    },

    "gt": {
      "EN": "greater than",
      "FR": "supérieur à",
      "ES": "mayor que"
    },
    "lt": {
      "EN": "less than",
      "FR": "inférieur à",
      "ES": "menor que"
    },
    "gte": {
      "EN": "greater than or equal to",
      "FR": "supérieur ou égal à",
      "ES": "mayor o igual que"
    },
    "lte": {
      "EN": "less than or equal to",
      "FR": "inférieur ou égal à",
      "ES": "menor o igual que"
    },
    "in": {
      "EN": "in",
      "FR": "dans",
      "ES": "en"
    },
    "notin": {
      "EN": "not in",
      "FR": "pas dans",
      "ES": "no está en"
    },
    "Conversion": {
      "EN": "Conversion",
      "FR": "Conversion",
      "ES": "Conversión"
    },
    "Convert": {
      "EN": "Convert",
      "FR": "Convertir",
      "ES": "Convertir"
    },
    "using": {
      "EN": "using",
      "FR": "en utilisant",
      "ES": "usando"
    },
    "find in column": {
      "EN": "find in column",
      "FR": "trouver dans la colonne",
      "ES": "encontrar en la columna"
    },
    "and return column": {
      "EN": "and return column",
      "FR": "et renvoyer la colonne",
      "ES": "y devolver la columna"
    },
    "Choose column": {
      "EN": "Choose column",
      "FR": "Choisissez la colonne",
      "ES": "Elija la columna"
    },
    "Add condition group": {
      "EN": "Add condition group",
      "FR": "Ajouter un groupe de conditions",
      "ES": "Agregar grupo de condiciones"
    },
    "Add condition": {
      "EN": "Add condition",
      "FR": "Ajouter une condition",
      "ES": "Agregar condición"
    },
    "Remove condition": {
      "EN": "Remove condition",
      "FR": "Supprimer la condition",
      "ES": "Eliminar condición"
    },
    "Select your condition type": {
      "EN": "Select your condition type",
      "FR": "Sélectionnez votre type de condition",
      "ES": "Seleccione su tipo de condición"
    },
    "type:if": {
      "EN": "If",
      "FR": "Si",
      "ES": "Si"
    },
    "type:sensor": {
      "EN": "Sensor",
      "FR": "Capteur",
      "ES": "Sensor"
    },
    "sensor": {
      "EN": "sensor",
      "FR": "capteur",
      "ES": "sensor"
    },
    "Temperature": {
      "EN": "Temperature",
      "FR": "Température",
      "ES": "Temperatura"
    },
    "Value": {
      "EN": "Value",
      "FR": "Valeur",
      "ES": "Valor"
    },
    "Sensor variable": {
      "EN": "Sensor variable",
      "FR": "Variable de capteur",
      "ES": "Variable del sensor"
    },
    "Tolerance": {
      "EN": "Tolerance",
      "FR": "Tolérance",
      "ES": "Tolerancia"
    }

  },
  "ProcessDesignerTest": {
    "Process in test mode": {
      "EN": "Process in test mode",
      "FR": "Processus en mode test",
      "ES": "Proceso en modo de prueba"
    }
  },
  "ProcessPage": {
    "Try again": {
      "EN": "Try again",
      "FR": "Réessayer",
      "ES": "Intentar de nuevo"
    },
    "Leave troubleshoot": {
      "EN": "Leave troubleshoot",
      "FR": "Quitter le dépannage",
      "ES": "Salir del diagnóstico"
    },
    "You are about to leave the troubleshooting mode. Please confirm if you want to quit and discard any ongoing diagnostics.": {
      "EN": "You are about to leave the troubleshooting mode. Please confirm if you want to quit and discard any ongoing diagnostics.",
      "FR": "Vous êtes sur le point de quitter le mode dépannage. Veuillez confirmer si vous souhaitez quitter et annuler tout diagnostic en cours.",
      "ES": "Está a punto de salir del modo de solución de problemas. Por favor, confirme si desea salir y descartar cualquier diagnóstico en curso."
    },
    "Report an issue": {
      "EN": "Report an issue",
      "FR": "Signaler un problème",
      "ES": "Informar de un problema"
    },
    "Back": {
      "EN": "Back",
      "FR": "Retour",
      "ES": "Atrás"
    },
    "Next": {
      "EN": "Next",
      "FR": "Suivant",
      "ES": "Siguiente"
    },
    "Home": {
      "EN": "Home",
      "FR": "Accueil",
      "ES": "Inicio"
    },
    "End": {
      "EN": "End",
      "FR": "Fin",
      "ES": "Fin"
    },
    "Did the troubleshooting...": {
      "EN": "Did the troubleshooting process help you resolve your issue? Please rate your experience.",
      "FR": "Est-ce que le processus de dépannage vous a aidé à résoudre votre problème ? Veuillez évaluer votre expérience.",
      "ES": "¿El proceso de resolución de problemas le ayudó a resolver su problema? Por favor califique su experiencia."
    },
    "Send review": {
      "EN": "Send review",
      "FR": "Envoyer l'avis",
      "ES": "Enviar reseña"
    },
    "Contact technical support": {
      "EN": "Contact technical support",
      "FR": "Contacter le support technique",
      "ES": "Contactar con soporte técnico"
    },
    "Please rate your experience on a scale from 1 to 5 stars.": {
      "EN": "Please rate your experience on a scale from 1 to 5 stars.",
      "FR": "Veuillez évaluer votre expérience sur une échelle de 1 à 5 étoiles.",
      "ES": "Por favor califique su experiencia en una escala de 1 a 5 estrellas."
    },
    "Thank you for submitting your review.": {
      "EN": "Thank you for submitting your review.",
      "FR": "Merci d'avoir soumis votre avis.",
      "ES": "Gracias por enviar su reseña."
    }
  },
  "ProcessDesignerGroup": {
    "The title is already used by another group. Please choose a unique title for this group.": {
      "EN": "The title is already used by another group. Please choose a unique title for this group.",
      "FR": "Le titre est déjà utilisé par un autre groupe. Veuillez choisir un titre unique pour ce groupe.",
      "ES": "El título ya está siendo utilizado por otro grupo. Por favor, elige un título único para este grupo."
    }
  },
  "ProcessDesignerSchemaModal": {
    "Title": {
      "EN": "Title",
      "FR": "Titre",
      "ES": "Título"
    },
    "The specified step title already exists. Please choose a unique title for this step.": {
      "EN": "The specified step title already exists. Please choose a unique title for this step.",
      "FR": "Le titre d'étape spécifié existe déjà. Veuillez choisir un titre unique pour cette étape.",
      "ES": "El título de paso especificado ya existe. Por favor, elija un título único para este paso."
    },
    "Yes/No Question Text": {
      "EN": "Yes/No Question Text",
      "FR": "Texte de question Oui/Non",
      "ES": "Texto de pregunta de Sí/No"
    },
    "Yes/No ID": {
      "EN": "Yes/No ID",
      "FR": "Identifiant Oui/Non",
      "ES": "ID de Sí/No"
    }
  },
  "BrandPage": {
    "Brand": {
      "EN": "Brand",
      "FR": "Marque",
      "ES": "Marca"
    }
  },
  "T_Brand": {
    "code": {
      "EN": "Code",
      "FR": "Code",
      "ES": "Código"
    },
    "label": {
      "EN": "Label",
      "FR": "Étiquette",
      "ES": "Etiqueta"
    },
    "isActive": {
      "EN": "Active",
      "FR": "Actif",
      "ES": "Activo"
    }
  },
  "AdminProduct":{
    "Duplicate to": {
      "EN": "Duplicate to",
      "FR": "Dupliquer vers",
      "ES": "Duplicar a"
    },
    "Duplicate files to others products": {
      "EN": "Duplicate files to others products",
      "FR": "Dupliquer les fichiers vers d'autres produits",
      "ES": "Duplicar archivos a otros productos"
    },
    "Choose the destination products for file duplication. Please be aware that this action will overwrite the existing documents in all selected target products.": {
      "EN": "Choose the destination products for file duplication. Please be aware that this action will overwrite the existing documents in all selected target products.",
      "FR": "Choisissez les produits de destination pour la duplication des fichiers. Veuillez noter que cette action écrasera les documents existants dans tous les produits cibles sélectionnés.",
      "ES": "Elija los productos de destino para la duplicación de archivos. Tenga en cuenta que esta acción sobrescribirá los documentos existentes en todos los productos de destino seleccionados."
    },
    "Please select at least one product to duplicate the files.": {
      "EN": "Please select at least one product to duplicate the files.",
      "FR": "Veuillez sélectionner au moins un produit pour dupliquer les fichiers.",
      "ES": "Por favor, seleccione al menos un producto para duplicar los archivos."
    },
    "Are you sure you want to duplicate the files to the following products: {listSelected}?": {
      "EN": "Are you sure you want to duplicate the files to the following products: {listSelected} ?",
      "FR": "Êtes-vous sûr de vouloir dupliquer les fichiers vers les produits suivants : {listSelected} ?",
      "ES": "¿Está seguro de que desea duplicar los archivos a los siguientes productos: {listSelected}? "
    },
    "The product files have been modified and must be saved before duplicating. Please save your changes to continue.": {
      "EN": "The product files have been modified and must be saved before duplicating. Please save your changes to continue.",
      "FR": "Les fichiers du produit ont été modifiés et doivent être enregistrés avant de dupliquer. Veuillez enregistrer vos modifications pour continuer.",
      "ES": "Los archivos del producto han sido modificados y deben guardarse antes de duplicar. Por favor, guarde sus cambios para continuar."
    },
    "Selected products: ": {
      "EN": "Selected products: ",
      "FR": "Produits sélectionnés : ",
      "ES": "Productos seleccionados : "
    },
    "Product": {
      "EN": "Product",
      "FR": "Produit",
      "ES": "Producto"
    },
    "Confirmation": {
      "EN": "Confirmation",
      "FR": "Confirmation",
      "ES": "Confirmación"
    },
    "Process parameters": {
      "EN": "Process parameters",
      "FR": "Paramètres du Processus",
      "ES": "Parámetros del proceso"
    },
    "Troubleshooting Process": {
      "EN": "Troubleshooting Process",
      "FR": "Processus de dépannage",
      "ES": "Proceso de solución de problemas"
    },
    "Choose a troubleshooting process": {
      "EN": "Choose a troubleshooting process",
      "FR": "Choisissez un processus de dépannage",
      "ES": "Elige un proceso de solución de problemas"
    },
    "Confirm selection": {
      "EN": "Confirm selection",
      "FR": "Confirmer la sélection",
      "ES": "Confirmar selección"
    },
    "Display Process": {
      "EN": "Display Process",
      "FR": "Afficher le Processus",
      "ES": "Mostrar Proceso"
    },
    "Choose": {
      "EN": "Choose",
      "FR": "Choisir",
      "ES": "Elegir"
    },
    "Select": {
      "EN": "Select",
      "FR": "Sélectionner",
      "ES": "Seleccionar"
    },
    "Display": {
      "EN": "Display",
      "FR": "Afficher",
      "ES": "Mostrar"
    },
    "Are you certain you wish to proceed...": {
      "EN": "Are you certain you wish to proceed with the deletion of this product? This action cannot be undone.",
      "FR": "Êtes-vous sûr(e) de vouloir procéder à la suppression de ce produit ? Cette action ne peut pas être annulée.",
      "ES": "¿Estás seguro(a) de que deseas proceder con la eliminación de este producto? Esta acción no se puede deshacer."
    },
    "Would you like to remove this troubleshooting process from this product?": {
      "EN": "Would you like to remove the troubleshooting process from this product?",
      "FR": "Souhaitez-vous supprimer ce processus de dépannage de ce produit ?",
      "ES": "¿Desea eliminar este proceso de resolución de problemas de este producto?"
    },
    "Would you like to remove this file from this product?": {
      "EN": "Would you like to remove this file from this product?",
      "FR": "Voulez-vous supprimer ce fichier de ce produit ?",
      "ES": "¿Le gustaría eliminar este archivo de este producto?"
    },
    "Add file": {
      "EN": "Add file",
      "FR": "Ajouter un fichier",
      "ES": "Agregar archivo"
    }
  },
  "T_Product": {
    "code": {
      "EN": "Code",
      "FR": "Code",
      "ES": "Código"
    },
    "label": {
      "EN": "Label",
      "FR": "Étiquette",
      "ES": "Etiqueta"
    },
    "brand": {
      "EN": "Brand",
      "FR": "Marque",
      "ES": "Marca"
    },
    "productCategory": {
      "EN": "Category",
      "FR": "Catégorie",
      "ES": "Categoría"
    },
    "productType": {
      "EN": "Type",
      "FR": "Type",
      "ES": "Tipo"
    },
    "productFamily": {
      "EN": "Family",
      "FR": "Famille",
      "ES": "Familia"
    },
    "process": {
      "EN": "Process",
      "FR": "Processus",
      "ES": "Proceso"
    },
    "tags": {
      "EN": "Tags",
      "FR": "Balises",
      "ES": "Etiquetas"
    },
    "isActive": {
      "EN": "Active",
      "FR": "Actif",
      "ES": "Activo"
    },
    "productFile": {
      "EN": "Documentation",
      "FR": "Documentation",
      "ES": "Documentación"
    },
    "virtualAssistant": {
      "EN": "Virtual Assistant",
      "FR": "Assistant Virtuel",
      "ES": "Asistente Virtual"
    },
    "This product doesn't exist.": {
      "EN": "This product doesn't exist.",
      "FR": "Ce produit n'existe pas.",
      "ES": "Este producto no existe."  
    },
    "Duplicate Code": {
      "EN": "Duplicate code found, please use a unique code.",
      "FR": "Code en double trouvé, veuillez utiliser un code unique.",
      "ES": "Código duplicado encontrado, por favor use un código único."
    },
    "This brand doesn't exist.": {
      "EN": "This brand doesn't exist.",
      "FR": "Cette marque n'existe pas.",
      "ES": "Esta marca no existe."
    },
    "This product category doesn't exist.": {
      "EN": "This product category doesn't exist.",
      "FR": "Cette catégorie de produit n'existe pas.",
      "ES": "Esta categoría de producto no existe."
    },
    "This product type doesn't exist.": {
      "EN": "This product type doesn't exist.",
      "FR": "Ce type de produit n'existe pas.",
      "ES": "Este tipo de producto no existe."
    },
    "This product family doesn't exist.": {
      "EN": "This product family doesn't exist.",
      "FR": "Cette famille de produits n'existe pas.",
      "ES": "Esta familia de productos no existe."
    },
    "This process doesn't exist.": {
      "EN": "This process doesn't exist.",
      "FR": "Ce processus n'existe pas.",
      "ES": "Este proceso no existe."
    },
    "To assist the virtual assistant in troubleshooting, please provide detailed information, such as similar products.": {
      "EN": "To assist the virtual assistant in troubleshooting, please provide detailed information, such as similar products.",
      "FR": "Pour aider l'assistant virtuel dans le dépannage, veuillez fournir des informations détaillées, telles que des produits similaires.",
      "ES": "Para ayudar al asistente virtual en la solución de problemas, proporcione información detallada, como productos similares."
    },
    "Virtual assistant": {
      "EN": "Virtual assistant",
      "FR": "Assistant virtuel",
      "ES": "Asistente virtual"
    }



  },
  "Troubleshoot": {
    "Model, serial number, brand, category, etc...": {
      "EN": "Model, serial number, brand, category, etc...",
      "FR": "Modèle, numéro de série, marque, catégorie, etc...",
      "ES": "Modelo, número de serie, marca, categoría, etc..."
    },
    "Search by keywords": {
      "EN": "Search by keywords",
      "FR": "Rechercher par mots-clés",
      "ES": "Buscar por palabras clave"
    },
    "SearchByModelBrandCategory": {
      "EN": "Search by model, brand, category, etc...",
      "FR": "Rechercher par modèle, marque, catégorie, etc...",
      "ES": "Buscar por modelo, marca, categoría, etc..."
    },
    "Troubleshooting": {
      "EN": "Troubleshooting",
      "FR": "Dépannage",
      "ES": "Solución de problemas"
    },
    "Search by serial number": {
      "EN": "Search by serial number",
      "FR": "Recherche par numéro de série",
      "ES": "Buscar por número de serie"
    },
    "Search by model number": {
      "EN": "Search by model number",
      "FR": "Recherche par numéro de modèle",
      "ES": "Buscar por número de modelo"
    },
    "Search by categories": {
      "EN": "Search by categories",
      "FR": "Recherche par catégories",
      "ES": "Buscar por categorías"
    },
    "On which product do you require assistance with troubleshooting?": {
      "EN": "On which product do you require assistance with troubleshooting?",
      "FR": "Sur quel produit avez-vous besoin d'aide pour le dépannage?",
      "ES": "¿En qué producto necesita ayuda con la solución de problemas?"
    },
    "Searching": {
      "EN": "Searching",
      "FR": "Recherche en cours",
      "ES": "Buscando"
    },
    "Search results": {
      "EN": "Search results",
      "FR": "Résultats de la recherche",
      "ES": "Resultados de la búsqueda"
    },
    "No results found.": {
      "EN": "No results found.",
      "FR": "Aucun résultat trouvé.",
      "ES": "No se encontraron resultados."
    },
    "Product details": {
      "EN": "Product details",
      "FR": "Détails du produit",
      "ES": "Detalles del producto"
    },
    "Search": {
      "EN": "Search",
      "FR": "Rechercher",
      "ES": "Buscar"
    },
    "Serial Number": {
      "EN": "Serial Number",
      "FR": "Numéro de série",
      "ES": "Número de serie"
    }
  },
  "ProcessReport": {
    "Report an issue": {
      "EN": "Report an issue",
      "FR": "Signaler un problème",
      "ES": "Informar de un problema"
    },
    "Product": {
      "EN": "Product",
      "FR": "Produit",
      "ES": "Producto"
    },
    "Issue": {
      "EN": "Issue",
      "FR": "Problème",
      "ES": "Problema"
    },
    "Send": {
      "EN": "Send",
      "FR": "Envoyer",
      "ES": "Enviar"
    }
  },
  "ReportPage": {
    "Issue": {
      "EN": "Issue",
      "FR": "Problème",
      "ES": "Problema"
    },
    "Report": {
      "EN": "Report",
      "FR": "Rapport",
      "ES": "Informe"
    },
    "Product Category": {
      "EN": "Product Category",
      "FR": "Catégorie de Produit",
      "ES": "Categoría de Producto"
    },
    "Product Type": {
      "EN": "Product Type",
      "FR": "Type de Produit",
      "ES": "Tipo de Producto"
    },
    "Product Family": {
      "EN": "Product Family",
      "FR": "Famille de Produit",
      "ES": "Familia de Producto"
    },
    "Product Model": {
      "EN": "Product Model",
      "FR": "Modèle de Produit",
      "ES": "Modelo de Producto"
    },
    "User Email": {
      "EN": "User Email",
      "FR": "Email de l'Utilisateur",
      "ES": "Correo Electrónico del Usuario"
    },
    "User Name": {
      "EN": "User Name",
      "FR": "Nom de l'Utilisateur",
      "ES": "Nombre del Usuario"
    },
    "Step Title": {
      "EN": "Step Title",
      "FR": "Titre de l'Étape",
      "ES": "Título del Paso"
    },
    "Report Date": {
      "EN": "Report Date",
      "FR": "Date du Rapport",
      "ES": "Fecha del Informe"
    },
    "Report Status": {
      "EN": "Report Status",
      "FR": "Statut du Rapport",
      "ES": "Estado del Informe"
    },
    "Change Status": {
      "EN": "Change Status",
      "FR": "Changer le Statut",
      "ES": "Cambiar el Estado"
    }
  },
  "T_Report": {
    "sequenceId": {
      "EN": "Id",
      "FR": "Id",
      "ES": "Id"
    },
    "process": {
      "EN": "Process",
      "FR": "Processus",
      "ES": "Proceso"
    },
    "brand": {
      "EN": "Brand",
      "FR": "Marque",
      "ES": "Marca"
    },
    "product": {
      "EN": "Product",
      "FR": "Produit",
      "ES": "Producto"
    },
    "user": {
      "EN": "User",
      "FR": "Utilisateur",
      "ES": "Usuario"
    },
    "step": {
      "EN": "Step",
      "FR": "Étape",
      "ES": "Paso"
    },
    "date": {
      "EN": "Date",
      "FR": "Date",
      "ES": "Fecha"
    },
    "status": {
      "EN": "Status",
      "FR": "Statut",
      "ES": "Estado"     
    }
  },
  "ProcessLogPage": {
    "Review": {
      "EN": "Review",
      "FR": "Revue",
      "ES": "Revisión"
    },
    "Rating": {
      "EN": "Rating",
      "FR": "Évaluation",
      "ES": "Calificación"
    },
    "Process Logs": {
      "EN": "Process Logs",
      "FR": "Journaux de traitement",
      "ES": "Registros de proceso"
    },
    "Product Model": {
      "EN": "Product Model",
      "FR": "Modèle de produit",
      "ES": "Modelo de producto"
    },
    "Brand": {
      "EN": "Brand",
      "FR": "Marque",
      "ES": "Marca"
    },
    "Log Date": {
      "EN": "Log Date",
      "FR": "Date du journal",
      "ES": "Fecha del registro"
    },
    "User Email": {
      "EN": "User Email",
      "FR": "Email de l'Utilisateur",
      "ES": "Correo Electrónico del Usuario"
    },
    "User Name": {
      "EN": "User Name",
      "FR": "Nom de l'Utilisateur",
      "ES": "Nombre del Usuario"
    },
  },
  "T_ProcessLog": {
    "sequenceId": {
      "EN": "Id",
      "FR": "Id",
      "ES": "Id"
    },
    "process": {
      "EN": "Process",
      "FR": "Processus",
      "ES": "Proceso"
    },
    "brand": {
      "EN": "Brand",
      "FR": "Marque",
      "ES": "Marca"
    },
    "product": {
      "EN": "Product",
      "FR": "Produit",
      "ES": "Producto"
    },
    "user": {
      "EN": "User",
      "FR": "Utilisateur",
      "ES": "Usuario"
    },
    "review": {
      "EN": "Review",
      "FR": "Revue",
      "ES": "Revisión"
    },
    "date": {
      "EN": "Date",
      "FR": "Date",
      "ES": "Fecha"
    },
  },
  "UserPage": {
    "User Administration": {
      "EN": "User Administration",
      "FR": "Administration des Utilisateurs",
      "ES": "Administración de Usuarios"
    },
    "User": {
      "EN": "User",
      "FR": "Utilisateur",
      "ES": "Usuario"
    },
    "Reset Password": {
      "EN": "Reset Password",
      "FR": "Réini. Mot de Passe",
      "ES": "Restablecer la Contraseña"
    },
    "This action will reset the user's password...": {
      "EN": "This action will reset the user's password. They will need to input a new password on their next login.",
      "FR": "Cette action réinitialisera le mot de passe de l'utilisateur. Il devra saisir un nouveau mot de passe lors de sa prochaine connexion.",
      "ES": "Esta acción restablecerá la contraseña del usuario. Tendrá que introducir una nueva contraseña en su próximo inicio de sesión."
    },
    "The user's password has been reset, and an email..." : {
      "EN": "The user's password has been reset, and an email with a temporary password has been sent.",
      "FR": "Le mot de passe de l'utilisateur a été réinitialisé, et un email avec un mot de passe temporaire a été envoyé.",
      "ES": "La contraseña del usuario ha sido restablecida y se ha enviado un correo electrónico con una contraseña temporal."
    },
    "The user's password has been reset": {
      "EN": "The user's password has been reset",
      "FR": "Le mot de passe de l'utilisateur a été réinitialisé",
      "ES": "Se ha restablecido la contraseña del usuario"
    },
    "Validate": {
      "EN": "Validate",
      "FR": "Valider",
      "ES": "Validar"
    },
    "By validating this account, the user will gain access to this application.": {
      "EN": "By validating this account, the user will gain access to this application.",
      "FR": "En validant ce compte, l'utilisateur aura accès à cette application.",
      "ES": "Al validar esta cuenta, el usuario obtendrá acceso a esta aplicación."
    },
    "This account has been validated.": {
      "EN": "This account has been validated.",
      "FR": "Ce compte a été validé.",
      "ES": "Esta cuenta ha sido validada."
    },
    "This account has been validated, and an email has been sent to the user.": {
      "EN": "This account has been validated, and an email has been sent to the user.",
      "FR": "Ce compte a été validé, et un email a été envoyé à l'utilisateur.",
      "ES": "Esta cuenta ha sido validada y se ha enviado un correo electrónico al usuario."
    },
  },
  "T_User": {
    "lastLoginAt": {
      "EN": "Last Login",
      "FR": "Dernière Connexion",
      "ES": "Último Inicio de Sesión"
    },
    "email": {
      "EN": "Email",
      "FR": "Email",
      "ES": "Correo Electrónico"
    },
    "firstName": {
      "EN": "First Name",
      "FR": "Prénom",
      "ES": "Nombre"
    },
    "lastName": {
      "EN": "Last Name",
      "FR": "Nom de Famille",
      "ES": "Apellido"
    },
    "companyName": {
      "EN": "Company",
      "FR": "Entreprise",
      "ES": "Empresa"
    },
    "role": {
      "EN": "Role",
      "FR": "Rôle",
      "ES": "Rol"
    },
    "isValid": {
      "EN": "Validated",
      "FR": "Validé",
      "ES": "Validado"
    },
    "isVerified": {
      "EN": "Verified",
      "FR": "Vérifié",
      "ES": "Verificado"
    },
    "isLocked": {
      "EN": "Locked",
      "FR": "Verrouillé",
      "ES": "Bloqueado"
    },
    "isActive": {
      "EN": "Active",
      "FR": "Actif",
      "ES": "Activo"
    },
    "language": {
      "EN": "Language",
      "FR": "Langue",
      "ES": "Idioma"
    },
    "temperatureUnit": {
      "EN": "Temperature Unit",
      "FR": "Unité de Température",
      "ES": "Unidad de Temperatura"
    }    
  },
  "variableValidator": {
    "InitScript Action Value Error": {
      "EN": "Script '{ScriptName}' in initialization script assign this variable to value '{VariableValue}'. This value is invalid with the variable type {VariableType}.",
      "FR": "Script '{ScriptName}' dans le script d'initialisation assign la valeur '{VariableValue}' à la variable. Cette valeur est invalide avec le type de variable {VariableType}.",
      "ES": "Script '{ScriptName}' en el script de inicialización, establezca esta variable en el valor '{VariableValue}'. Este valor no es válido con el tipo de variable {VariableType}."
    },
    "InitScript Condition Value Error": {
      "EN": "Script '{ScriptName}' in initialization script compares this variable to value '{VariableValue}'. This value is invalid with the variable type {VariableType}.",
      "FR": "Le script '{ScriptName}' dans le script d'initialisation compare cette variable à la valeur '{VariableValue}'. Cette valeur est invalide pour le type de variable {VariableType}.",
      "ES": "El script '{ScriptName}' en el script de inicialización compara esta variable con el valor '{VariableValue}'. Este valor no es válido para el tipo de variable {VariableType}."
    },
    "Step Condition Type Literal Error": {
      "EN": "Step '{StepSource}' has a condition to Step '{StepTarget}' that compares this variable to literal value '{VariableValue}'. This is invalid with the variable type {VariableType}.",
      "FR": "L'étape '{StepSource}' a une condition vers l'étape '{StepTarget}' qui compare cette variable à la valeur littérale '{VariableValue}'. Ceci est invalide avec le type de variable {VariableType}.",
      "ES": "El paso '{StepSource}' tiene una condición hacia el paso '{StepTarget}' que compara esta variable con el valor literal '{VariableValue}'. Esto no es válido con el tipo de variable {VariableType}."
    },
    "Error(s) during validation": {
      "EN": "Error(s) during validation",
      "FR": "Erreur(s) lors de la validation",
      "ES": "Error(es) durante la validación"
    },
    "You have to solve those errors before saving your modification.": {
      "EN": "You have to solve those errors before saving your modification.",
      "FR": "Vous devez résoudre ces erreurs avant de sauvegarder votre modification.",
      "ES": "Debe resolver esos errores antes de guardar su modificación."
    }
  },
  "TroubleshootProduct": {
    "Product": {
      "EN": "Product",
      "FR": "Produit",
      "ES": "Producto"
    },
    "Model": {
      "EN": "Model",
      "FR": "Modèle",
      "ES": "Modelo"
    },
    "Brand": {
      "EN": "Brand",
      "FR": "Marque",
      "ES": "Marca"
    },
    "Category": {
      "EN": "Category",
      "FR": "Catégorie",
      "ES": "Categoría"
    },
    "Documentation": {
      "EN": "Documentation",
      "FR": "Documentations",
      "ES": "Documentacións"
    },
    "Troubleshooting": {
      "EN": "Troubleshooting",
      "FR": "Dépannage",
      "ES": "Solución de problemas"
    },
    "Virtual Assistant": {
      "EN": "Virtual Assistant",
      "FR": "Assistant Virtuel",
      "ES": "Asistente Virtual"
    },
    "Customer Support": {
      "EN": "Customer Support",
      "FR": "Support Client",
      "ES": "Soporte al Cliente"
    }

  },
  "TroubleshootVirtual": {
    "Virtual Assistant": {
      "EN": "Virtual Assistant",
      "FR": "Assistant Virtuel",
      "ES": "Asistente Virtual"
    },
    "Virtual assistant": {
      "EN": "Virtual assistant",
      "FR": "Assistant virtuel",
      "ES": "Asistente virtual"
    },
    "You": {
      "EN": "You",
      "FR": "Vous",
      "ES": "Usted"
    },
    "Send": {
      "EN": "Send",
      "FR": "Envoyer",
      "ES": "Enviar"
    },
    "I am a virtual assistant for Innovair Solutions, specialists in heating...": {
      "EN": "I am a virtual assistant for Innovair Solutions, specialists in heating, air conditioning, and ventilation. I'm here to assist you with any questions or issues related to the {model} product. Simply provide the error code or describe the issue, and I'll help you find a solution.",
      "FR": "Je suis un assistant virtuel pour Innovair Solutions, spécialistes du chauffage, de la climatisation et de la ventilation. Je suis là pour vous aider avec toutes vos questions ou problèmes concernant le produit {model}. Fournissez simplement le code d'erreur ou décrivez le problème, et je vous aiderai à trouver une solution.",
      "ES": "Soy un asistente virtual de Innovair Solutions, especialistas en calefacción, aire acondicionado y ventilación. Estoy aquí para ayudarle con cualquier pregunta o problema relacionado con el producto {model}. Simplemente proporcione el código de error o describa el problema, y le ayudaré a encontrar una solución."
    },
    "Warning: Alpha Version": {
      "EN": "Warning: Alpha Version",
      "FR": "Avertissement : Version Alpha",
      "ES": "Advertencia: Versión Alpha"
    },
    "This virtual assistant is in early development. Responses may be incomplete or inaccurate. Use with caution.": {
      "EN": "This virtual assistant is in early development. Responses may be incomplete or inaccurate. Use with caution.",
      "FR": "Cet assistant virtuel est en développement précoce. Les réponses peuvent être incomplètes ou inexactes. Utilisez avec prudence.",
      "ES": "Este asistente virtual está en desarrollo temprano. Las respuestas pueden ser incompletas o inexactas. Úselo con precaución."
    }
  },
  "PrivacyPage": {
    "Privacy Policy": {
      "EN": "Privacy Policy",
      "FR": "Politique de Confidentialité",
      "ES": "Política de Privacidad"
    },
  }
}
/*
"Yes": {
  "EN": "",
  "FR": "",
  "ES": ""
},

*/





export const setLanguage = (_code, _name, _refreshStorage = true) => {
  currentLanguage = _code;

  
  if (_name == ""){
      if (_code == "FR") currentLanguageName = "Français"
      if (_code == "ES") currentLanguageName = "Español"
      else currentLanguageName = "English"
  }else currentLanguageName = _name;

  if (_refreshStorage)
    localStorage.setItem(Global.language, currentLanguage || "EN");
  
};

export const getLanguage = () => {
  return {
    code: currentLanguage,
    label: currentLanguageName
  }
};

export const getLabel = (_component, _label, _parameter = undefined) => {



  try
  {

    let currentValue = "";

    if (!currentLanguage || currentLanguage == "")
      currentValue = Dictionary[_component][_label]["EN"];
    else
      currentValue = Dictionary[_component][_label][currentLanguage];

    if (!currentValue){
      currentValue = Dictionary[_component][_label]["EN"];

      if (!currentValue)
      {
        currentValue = Dictionary[_component][_label]["FR"];
      }

      if (!currentValue) throw new Error();
    }

    if (_parameter){

      //Regex for parameters
      const regex = /\{(\w+)\}/g;

      currentValue = currentValue.replace(regex, (match, p1) =>
      {
        return _parameter.hasOwnProperty(p1) ? _parameter[p1] : match;
      });

    }

    return currentValue;

  }catch(err){
    console.log(Dictionary[_component], _component, _label);
    return "Label error";
  }

  

  

};

let currentLanguage = "EN";
let currentLanguageName = "English"

let storageLanguage = localStorage.getItem(Global.language);

if (storageLanguage)
{

  setLanguage(storageLanguage, "", false);

} else
{

  const browserLanguage = navigator.language;

  if (browserLanguage.startsWith('fr'))
  {
    currentLanguage = "FR";
    currentLanguageName = "Français";
  } else if (browserLanguage.startsWith('es'))
  {
    currentLanguage = "ES";
    currentLanguageName = "Español";
  }

}
